/* This is a generated file, do not edit it directly */
export type { Country } from '@aerapass/country-data';
export type CountryCode =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';
export type BooleanMap = Record<string, boolean>;
export type FeatureRestrictedRegionMap = Partial<Record<Feature, BooleanMap>>;
export type FeatureRestrictedCountryRegionMap = Partial<
  Record<CountryCode, FeatureRestrictedRegionMap>
>;
export type CoreCurrencyConfigurations = Record<
  Scalars['NetworkCurrency'],
  CoreCurrencyNetworkConfiguration
>;
export type OpsCurrencyConfigurations = Record<
  Scalars['NetworkCurrency'],
  OpsCurrencyNetworkConfiguration
>;
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: string;
  AWSDateTime: string;
  AWSEmail: string;
  AWSIPAddress: string;
  AWSJSON: Record<string, unknown>;
  AWSPhone: string;
  AWSTime: string;
  AWSTimestamp: string;
  AWSURL: string;
  /** AccountID: an account's unique ID, of the form <UserID>/<CurrencyCode>/<Type> */
  AccountID: string;
  /** Address: an account or wallet address related to a transaction. Fireblocks = data.destinationAddress */
  Address: string;
  /** AddressRef: Destination tag for XRP, used as memo for EOS/XLM */
  AddressRef: string;
  /** AssetID:  A scalar representing a financial asset code. Suitable for use in cases where exactly one of the currency codes must be provided. */
  AssetID: string;
  /** BadgeTypeID: id of a badge type */
  BadgeTypeID: string;
  /** BooleanMap: a map of strings to booleans, e.g. { Foo: true } */
  BooleanMap: BooleanMap;
  /**
   * CoreCurrencyConfigurations: Core settings for currencies and their networks.
   * It is used to manage parameters for currencies, such as their unique identifiers, network-specific information, and precision attributes.
   */
  CoreCurrencyConfigurations: CoreCurrencyConfigurations;
  /** CountryCode: An ISO 3166-1 alpha-2 country code, type from https://github.com/annexare/Countries/blob/master/data/countries.3to2.json */
  CountryCode: CountryCode;
  /** CustomerID: ID of a customer */
  CustomerID: string;
  /** DDBTableName: DynamoDB Table name */
  DDBTableName: string;
  /** Decimal: arbitrary precision decimal number */
  Decimal: string;
  /** DynamoID: our internal DynamoDB identifier */
  DynamoID: string;
  /** ErrorObject: error object native to language */
  ErrorObject: string;
  /** EventID: the assigned gateway api identifier for each request */
  EventID: string;
  /** FeatureRestrictedCountryRegionMap: a map of CountryCodes (strings) to FeatureMaps e.g. { CA: { Withdraw: { '*': true } }, US: { Withdraw: { NY: true, TX: true } }} */
  FeatureRestrictedCountryRegionMap: FeatureRestrictedCountryRegionMap;
  /** FinServiceConfigurations: FinService settings for currency accounts and funding. */
  FinServiceConfigurations: any;
  /** FireblocksID: the transaction id used by Fireblocks = data.id */
  FireblocksID: string;
  /** JWT: JSON Web Token */
  JWT: string;
  /** KSUID: K-Sortable Unique Identifier */
  KSUID: string;
  /** MarketingCodeId: id of a a marketing code */
  MarketingCodeID: string;
  /**
   * MoonpayID: the transaction id used by Moonpay = data.id
   *
   * @deprecated Moonpay is deprecated and should not be used.
   */
  MoonpayID: any;
  /** NetworkCurrency: A concatenation of both the currency code and network, of the form <Network>/<CurrencyCode>. */
  NetworkCurrency: string;
  /** NoahID: our internal transaction id */
  NoahID: string;
  /** Nonce: a string which must be unique each time a new transaction is created, like a UUID or operation sequence number. Request can be idempotently retried by using the same Nonce. */
  Nonce: string;
  /**
   * OpsCurrencyConfigurations: Ops settings for currencies and their networks.
   * It is used to manage operational settings, such as minimum sweep amounts for account-based currencies and funding settings for re-balancing.
   */
  OpsCurrencyConfigurations: OpsCurrencyConfigurations;
  /** PaymentRequest: lightning payment request */
  PaymentRequest: string;
  /** PromoID: unique promotion identifier */
  PromoID: string;
  /** PublicID: the public blockchain transaction id or hash (if available). Fireblocks = data.txHash */
  PublicID: string;
  /** QuestID: id of a quest */
  QuestID: string;
  /** QuestTaskID: id of a quest task */
  QuestTaskID: string;
  /** RegionCode: An ISO 3166-1 style postal abbreviation code of a region */
  RegionCode: string;
  /** SigningKeyID: ID of a user signing key, of the form <UserID>/<SigningDocumentType> */
  SigningKeyID: string;
  /** UUID: Unique identifier in format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx */
  UUID: string;
  /** UserID: user's id - equal to the auth Identity Sub */
  UserID: string;
  /** WhitelistID: identifies a whitelist address */
  WhitelistID: string;
  /** WithdrawOrderID: id for withdraw order */
  WithdrawOrderID: string;
};

export type AwsEventBridgeEntry = {
  ErrorCode?: Maybe<Scalars['String']>;
  ErrorMessage?: Maybe<Scalars['String']>;
  EventId: Scalars['String'];
};

export type AwsEventBridgeResponse = {
  Entries: Array<AwsEventBridgeEntry>;
  FailedEntryCount: Scalars['Int'];
};

/** Account: an account belonging to a user. */
export type Account = {
  /** AccountType: type of account e.g. current / savings / loan */
  AccountType: AccountType;
  /** Created: date when the account was created */
  Created: Scalars['AWSDateTime'];
  /** CurrencyCode: the currency code of this account's base currency e.g. BTC / ETH */
  CurrencyCode: CurrencyCode;
  /** ID: this account's unique ID, of the form <UserID>/<CurrencyCode>/<Type> */
  ID: Scalars['AccountID'];
  /** UserID: identifies the owner of this account */
  UserID: Scalars['UserID'];
  /** WhitelistAddresses: Whitelisted addresses */
  WhitelistAddresses?: Maybe<Array<WhitelistAddress>>;
};

export type AccountBalance = AccountBalanceCurrent;

/** AccountBalanceCurrent: balance of a current account. */
export type AccountBalanceCurrent = {
  /** AccountType: type of account to create e.g. current / savings / loan */
  AccountType: AccountType;
  /** Available: The balance available for new transactions */
  Available: Scalars['Decimal'];
  /** ID: the ID of the account this balance belongs to, of the form <UserID>/<CurrencyCode>/<Type> */
  ID: Scalars['AccountID'];
  /** Lifetime: Total accrued */
  Lifetime: Scalars['Decimal'];
  /** Total: The current reconciled total */
  Total: Scalars['Decimal'];
};

/** AccountCreateInput: Graphql input to request to create an account (UserID will come from JWT) */
export type AccountCreateInput = {
  /** AccountType: type of account to create e.g. current / savings / loan */
  AccountType: AccountType;
  /** CurrencyCode: the currency code of the account's base currency e.g. BTC / ETH */
  CurrencyCode: CurrencyCode;
  /** DepositAddressRequest: use to query or create a deposit address for a specific network. */
  DepositAddressRequest?: InputMaybe<DepositAddressRequest>;
};

export type AccountCreateResponse = {
  /** Account: an account belonging to a user */
  Account: Account;
  /** DepositAddresses: addresses where user can directly deposit funds */
  DepositAddresses?: Maybe<Array<DepositAddress>>;
};

export type AccountHolderDetails = {
  /**
   * Address: the address of the account owner. This should match the
   * payment method records.
   */
  Address?: Maybe<StreetAddress>;
  /** Identity: account holder identity */
  Identity?: Maybe<CustomerIdentity>;
  /**
   * Name: the name of the owner of the account. This should match
   * the payment method records.
   */
  Name?: Maybe<FullName>;
  /** PhoneNumber: the phone number associated with the payment method */
  PhoneNumber?: Maybe<Scalars['AWSPhone']>;
};

export type AccountHolderDetailsInput = {
  /**
   * Address: the address of the account owner. This should match the
   * bank records.
   */
  Address?: InputMaybe<StreetAddressInput>;
  /** Identity: account holder identity */
  Identity?: InputMaybe<CustomerIdentityInput>;
  /**
   * Name: the name of the owner of the account. This should match
   * the bank records.
   */
  Name?: InputMaybe<FullNameInput>;
  /** PhoneNumber: the phone number associated with the payment method */
  PhoneNumber?: InputMaybe<Scalars['AWSPhone']>;
};

/** AccountResponse: used to publish account updates to the app. */
export type AccountResponse = {
  /** AccountType: type of account e.g. current / savings / loan */
  AccountType: AccountType;
  /** Balance: balance in the account */
  Balance?: Maybe<AccountBalance>;
  /** CurrencyCode: the currency code of this account's base currency e.g. BTC / ETH */
  CurrencyCode: CurrencyCode;
  /** ID: this account's unique ID, of the form <UserID>/<CurrencyCode>/<Type> */
  ID: Scalars['AccountID'];
  /** Version: version of the account */
  Version: Scalars['Int'];
  /** VersionBalance: version of the account balance */
  VersionBalance: Scalars['Int'];
};

/** AccountType: type of account e.g. current / savings / loan */
export enum AccountType {
  /** Current: transactional account for on-demand funds */
  Current = 'Current',
  /** Savings: account for gaining income for capital */
  Savings = 'Savings',
}

export type AccountsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  reverseOrder?: InputMaybe<Scalars['Boolean']>;
};

export type AccountsPage = {
  items?: Maybe<Array<AccountResponse>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Action = {
  Type: ActionType;
};

export enum ActionType {
  Sell = 'Sell',
}

/** AddressFormat: address formats */
export enum AddressFormat {
  /** EvmCompatible: Ethereum virtual machine compatible hex address format */
  EvmCompatible = 'EvmCompatible',
  /** Segwit: Bitcoin P2WPKH address format */
  Segwit = 'Segwit',
  /** TronBase58: Tron Base58 address format starting with "T" (version byte 65) */
  TronBase58 = 'TronBase58',
}

/** AdminGroup: group that admin user can belong to */
export enum AdminGroup {
  /** Compliance: user can access compliance operations */
  Compliance = 'Compliance',
  /** FinOps: user can access financial operations */
  FinOps = 'FinOps',
}

/** AdminUser: administrative user */
export type AdminUser = {
  /** Email: Noah email address */
  Email: Scalars['String'];
  /** Groups: groups that the user belongs to */
  Groups?: Maybe<Array<AdminGroup>>;
  /** ID: identifies a Noah admin */
  ID: Scalars['UUID'];
  /** RetoolID: identifier in Retool */
  RetoolID?: Maybe<Scalars['String']>;
};

export enum AlertEvent {
  FinopsFinServiceTimeout = 'FinopsFinServiceTimeout',
  FinopsForceOperation = 'FinopsForceOperation',
  FinopsTransactionFailure = 'FinopsTransactionFailure',
  FinopsWithdrawOrderFailure = 'FinopsWithdrawOrderFailure',
  FinsopsInsufficientLiquidity = 'FinsopsInsufficientLiquidity',
}

export type AmountCondition = {
  ComparisonOperator: ComparisonOperator;
  Value: Scalars['Decimal'];
};

export type ApiAllowHeader = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ApiKey = {
  ApiKey?: Maybe<Scalars['String']>;
  Created: Scalars['AWSDateTime'];
  Expires?: Maybe<Scalars['AWSDateTime']>;
  KeyHash: Scalars['String'];
  Label: Scalars['String'];
  PublicKey?: Maybe<Scalars['String']>;
  Signature?: Maybe<Scalars['String']>;
  UserID: Scalars['UserID'];
};

/** ApiKeysIndexedFields: index fields on ledger apikeys table */
export enum ApiKeysIndexedFields {
  KeyHash = 'KeyHash',
}

export type AppConfigAnalytics = {
  datadogMetrics: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  identify: Scalars['Boolean'];
  track: Scalars['Boolean'];
};

export type AppConfigApple = {
  initiativeContext: AppConfigAppleInitiaveContext;
  merchantIdentifier: Scalars['String'];
};

export type AppConfigAppleInitiaveContext = {
  checkout: Scalars['String'];
  web: Scalars['String'];
};

/** AppConfigApplicationName: Enum containing values for AppConfig application names */
export enum AppConfigApplicationName {
  /** NoahConfigCoreV2: appconfig core application name */
  NoahConfigCoreV2 = 'NoahConfigCoreV2',
  /** NoahConfigOpsV2: appconfig ops application name */
  NoahConfigOpsV2 = 'NoahConfigOpsV2',
}

export type AppConfigAuth = {
  developer: Scalars['Boolean'];
  oryCookieName: Scalars['String'];
  oryCustomUrl: Scalars['String'];
  oryProjectSlug: Scalars['String'];
  oryUiURL: Scalars['String'];
  subscriptionJwtIssuer: Scalars['String'];
};

export type AppConfigAws = {
  captchaApi?: InputMaybe<AwsCaptchaApi>;
  captchaEnabled: Scalars['Boolean'];
};

export type AppConfigBusiness = {
  apiUrl: Scalars['String'];
  requirePublicKey: Scalars['Boolean'];
};

export type AppConfigCko = {
  cardHolderNameMatchThreshold: Scalars['Decimal'];
  entityID: Scalars['String'];
  eurAccountID: Scalars['String'];
  feeMinimumFiatAmount: Scalars['Decimal'];
  feePercentage: Scalars['Decimal'];
  /**
   * Remove these. Should have come from the /balances request but the SDK doesn't
   * support the withCurrencyAccountId param and there's no other way to get it
   * the account id. Checkout has provided us with these values via slack.
   */
  gbpAccountID: Scalars['String'];
  /**
   * minReserveAmount: How much balance to reserve. This will help deal with
   * potential race conditions when our balances are runing low. The actual
   * balance might still go below this amount in those scenarios.
   */
  minReserveFiatAmount: Scalars['Decimal'];
  minimumFiatAmount: Scalars['Decimal'];
  processingChannelId: Scalars['String'];
  slippagePercentage: Scalars['Decimal'];
  supportedFiatPaymentCards: Array<FiatPaymentCardScheme>;
  usdAccountID: Scalars['String'];
  webhookUrl: Scalars['String'];
};

/** AppConfigConfigurationName: Enum containing values for AppConfig configuration names */
export enum AppConfigConfigurationName {
  /** ConfigProfileCore: appconfig core configuration name */
  ConfigProfileCore = 'ConfigProfileCore',
  /** ConfigProfileOps: appconfig ops configuration name */
  ConfigProfileOps = 'ConfigProfileOps',
}

export type AppConfigCoreCurrencies = {
  configurations: Scalars['CoreCurrencyConfigurations'];
};

export type AppConfigCoreSigning = {
  coreSigningKeyArn: Scalars['String'];
};

export type AppConfigEthereum = {
  rpcUrl: Scalars['String'];
};

export type AppConfigFe = {
  checkout: AppConfigFeCheckout;
  web: AppConfigFeWeb;
};

export type AppConfigFeCheckout = {
  baseUrl: Scalars['String'];
  paymentMethodsUrl: Scalars['String'];
};

export type AppConfigFeWeb = {
  baseUrl: Scalars['String'];
  cko3DSReturnPath: Scalars['String'];
  enableDatadog: Scalars['Boolean'];
};

export type AppConfigFeature = {
  /** currencies: which currencies users can be permitted to access */
  currencies?: InputMaybe<Array<CurrencyCode>>;
  globalOverrides?: InputMaybe<Array<FeatureFlagInput>>;
  /** networks: which networks users can be permitted to access */
  networks?: InputMaybe<Array<Network>>;
  /**
   * policies: policies configures which users can access which features.
   * Features are disabled by default and can be added to policies to permit them.
   *
   * Policies set the baseline which can be augmented through:
   * * User overrides
   * * Global overrides
   * * Regions
   */
  policies?: InputMaybe<Array<AppConfigFeaturePolicy>>;
  profanityFilter: Scalars['Boolean'];
  regions: AppConfigFeatureRegions;
  systemStatus: SystemStatus;
};

export type AppConfigFeaturePolicy = {
  /**
   * currencies: currencies permitted by this policy.
   * Default is using AppConfigFeature.currencies.
   */
  currencies?: InputMaybe<Array<CurrencyCode>>;
  /**
   * features: features permitted by this policy.
   * Must be defined or no features are permitted by this policy.
   */
  features: Array<Feature>;
  /**
   * groups: groups this policy permits features for.
   * Default is everyone.
   */
  groups?: InputMaybe<Array<UserGroup>>;
  /**
   * networks: networks permitted by this policy.
   * Default is using AppConfigFeature.networks.
   */
  networks?: InputMaybe<Array<Network>>;
  /**
   * precedence: take precedence over global override / system status.
   * 1: take effect over global override
   * 2: take effect also over system status
   */
  precedence?: InputMaybe<Scalars['Int']>;
};

export type AppConfigFeatureRegions = {
  /** HighRiskCountries: countries we need to ask for extra documentation */
  HighRiskCountries: Scalars['BooleanMap'];
  /** ProhibitedCountries: countries that are entirely blocked from accessing the app */
  ProhibitedCountries: Scalars['BooleanMap'];
  /** RestrictedRegions: a complex type describing countries which have region-restricted features */
  RestrictedRegions: Scalars['FeatureRestrictedCountryRegionMap'];
};

export type AppConfigFireblocks = {
  finopsVault: Scalars['Int'];
  fuelPumpVault: Scalars['Int'];
  /** fundingForwardVaults: vault IDs from which funds will be forwarded to fundingWalletID */
  fundingForwardVaults: Array<Scalars['Int']>;
  /** fundingWalletID: internal wallet ID of the sytem|funding account */
  fundingWalletID: Scalars['String'];
  omnibusVault: Scalars['Int'];
  /** sync: indicating whether settings related to gas gas station and confirmation threshold should be syncronized with Fireblocks */
  sync: Scalars['Boolean'];
  testWalletVault: Scalars['Int'];
  withdrawVault: Scalars['Int'];
};

export type AppConfigFuelPump = {
  /** capacity: The amount in an intermediate vault up to which the gas station will fuel it */
  capacity: Scalars['Decimal'];
  /** threshold: The amount in an intermediate vault below which the gas station will fuel it */
  threshold: Scalars['Decimal'];
};

export type AppConfigFunding = {
  settings: Scalars['FinServiceConfigurations'];
};

export type AppConfigFundingBalanceSettings = {
  /** currency: the currency of the account */
  currency: Scalars['AssetID'];
  /** reference: identification of the account with the provider */
  reference: Scalars['String'];
  /**
   * scarcityThreshold: how much is the balance allowed to deviate into
   * insufficiency before triggering an order to top-up funds in the 3rd party.
   * 0 means 0% (not recomended because it would trigger a top-up order on any
   * deviation) and 100 means 100% (also not recomended because the top up would
   * only occur after the account is completely depleted).
   */
  scarcityThreshold: Scalars['Decimal'];
  /**
   * surplusThreshold: how much is the balance allowed to deviate in excess before
   * triggering an order to withdraw funds from the 3rd party. 0 means 0% (not
   * recomended because it would trigger a withdraw order on any deviation) and
   * 100 means 100% (trigger a withdraw order when the balance is double the
   * target amount).
   */
  surplusThreshold: Scalars['Decimal'];
  /** targetAmount: how much should the funding manager aim at keeping in this account */
  targetAmount: Scalars['Decimal'];
};

export type AppConfigFundingSettings = {
  /**
   * minimumFundingAmountUsd: The rebalancing process between the omnibus and withdrawal vaults is triggered when the calculated imbalance in USD surpasses this specified value.
   * Re-balancing won't occur if the difference is below this value.
   */
  minimumFundingAmountUsd: Scalars['Decimal'];
  /** targetShare: The target share of the omnibus vault represents the proportion of the total balance allocated to the withdrawal vault for the amount exceeding the threshold. */
  targetShare: Scalars['Decimal'];
  /** thresholdUsd: The omnibus vault balance is distributed equally between the omnibus vault and the withdrawal vault up to this specified threshold amount. */
  thresholdUsd: Scalars['Decimal'];
};

export type AppConfigGasStation = {
  /** address: The onchain address for the gas station used to identify auto-fuel events. */
  address: Scalars['Address'];
  /** capacity: The amount in an intermediate vault up to which the gas station will fuel it */
  capacity: Scalars['Decimal'];
  /** gasMaxPrice: The maximum gas price that is paid for an auto-fuel transaction. If not set there is no limit to the maximum transaction fee */
  gasMaxPrice?: InputMaybe<Scalars['Decimal']>;
  /** threshold: The amount in an intermediate vault below which the gas station will fuel it */
  threshold: Scalars['Decimal'];
};

export type AppConfigLightning = {
  addressDomain: Scalars['String'];
  callbackDomain: Scalars['String'];
};

export type AppConfigLimits = {
  /** btcSingleMinimumEur: The minimum amount of EUR required for a single BTC transaction */
  btcSingleMinimumEur: Scalars['Int'];
  /** dayLimitEur: The maximum amount of EUR that can be withdrawn in a day */
  dayLimitEur: Scalars['Int'];
  /** ethereumSingleMinimumEur: The minimum amount of EUR required for a single Ethereum transaction */
  ethereumSingleMinimumEur: Scalars['Int'];
  /** lnDayLimitEur: The maximum amount of EUR that can be transacted in a day via Lightning Network */
  lnDayLimitEur: Scalars['Int'];
  /** lnSingleLimitEur: The maximum amount of EUR for a single payment via Lightning Network */
  lnSingleLimitEur: Scalars['Int'];
  /** signingDayLimitEur: The maximum amount of EUR that can be withdrawn without a signature in a day */
  signingDayLimitEur: Scalars['Int'];
  /** signingSingleLimitEur: The maximum amount of EUR that can be withdrawn without a signature in a single transaction */
  signingSingleLimitEur: Scalars['Int'];
};

export type AppConfigLogger = {
  logLevel: LogLevel;
  mode: LoggerMode;
  stackTrace: Scalars['Boolean'];
};

export type AppConfigManualRamp = {
  settings: Array<InputMaybe<ManualRampCurrencySettings>>;
};

export type AppConfigMockServer = {
  grpcUrl: Scalars['String'];
  httpUrl: Scalars['String'];
};

export type AppConfigNetworkFee = {
  quoteExpirySec: Scalars['Int'];
};

export type AppConfigNetworkSettings = {
  /** confirmationThreshold: The required number of confirmations to treat a transaction as final */
  confirmationThreshold: Scalars['Int'];
  /** fuelPump: Settings for the fuel pump. If not set the fuel pump is disabled for this network. */
  fuelPump?: InputMaybe<AppConfigFuelPump>;
  /** gasStation: Settings for the gas station. If not set the gas station is disabled. */
  gasStation?: InputMaybe<AppConfigGasStation>;
  /** network: The specific network the settings apply to */
  network: Network;
  /** rpc: settings for rpc nodes of the network */
  rpc?: InputMaybe<RpcConnection>;
};

export type AppConfigNetworks = {
  settings: Array<AppConfigNetworkSettings>;
};

export type AppConfigOpsCurrencies = {
  configurations: Scalars['OpsCurrencyConfigurations'];
};

export type AppConfigProfileCore = {
  analytics: AppConfigAnalytics;
  apiAllowHeader: ApiAllowHeader;
  appEnv: AppEnvs;
  appStage: AppStages;
  apple: AppConfigApple;
  auth: AppConfigAuth;
  aws: AppConfigAws;
  business: AppConfigBusiness;
  cko: AppConfigCko;
  coreSigning: AppConfigCoreSigning;
  currencies: AppConfigCoreCurrencies;
  defaultRegion: Scalars['String'];
  ethereum: AppConfigEthereum;
  fe: AppConfigFe;
  fireblocks: AppConfigFireblocks;
  graphqlHost: Scalars['String'];
  lightning: AppConfigLightning;
  logger: AppConfigLogger;
  manualRamp: AppConfigManualRamp;
  mock: Scalars['Boolean'];
  mockServer: AppConfigMockServer;
  networkFee: AppConfigNetworkFee;
  remitee: AppConfigRemitee;
  repos: AppConfigRepos;
  revolut: AppConfigRevolut;
  signing: AppConfigSigning;
  ssm: AppConfigSsm;
  sumsub: AppConfigSumSub;
};

export type AppConfigProfileOps = {
  currencies: AppConfigOpsCurrencies;
  feature: AppConfigFeature;
  funding: AppConfigFunding;
  limits: AppConfigLimits;
  networks: AppConfigNetworks;
  risks: AppConfigRisks;
};

export type AppConfigRemitee = {
  debtor: RemiteeDebtor;
};

export type AppConfigRepos = {
  ddb: DdbTableNames;
  ledger: Ledger;
  s3: S3;
};

export type AppConfigRevolut = {
  /** webhookUrl: which url is used to receive webhooks from Revolut */
  webhookUrl: Scalars['String'];
};

export type AppConfigRisk = {
  /**
   * approveLevel:
   *
   * SARDINE auto approveLevel
   * Set this to control at which risk level our system auto-approves Sardine checks
   *
   * 0 = nothing (declines all in our system),
   * 1 = low,
   * 2 = medium_low,
   * 3 = medium,
   * 4 = high,
   * 5 = very_high (effectively auto-approves everything and acts like shadow mode)
   *
   * SCORECHAIN approveLevel
   * Set this to control at which risk level our system auto-approves Scorechain checks
   *
   * Scorechain risk scores at or above this number are auto-approved
   * 1: Critical
   * 2-29: High risk
   * 30-69: Medium risk
   * 70-99: Low risk
   * 100: No risk
   */
  approveLevel: Scalars['Int'];
  check: Scalars['Boolean'];
};

export type AppConfigRisks = {
  fiatBuyCustomer: AppConfigRisk;
  fiatSellCustomer: AppConfigRisk;
  kyc: AppConfigRisk;
  kycMaxRetries: Scalars['Int'];
  registrationDevice: AppConfigRisk;
  withdrawCustomer: AppConfigRisk;
};

export type AppConfigSsm = {
  /** overridePrefix: overrides environment's parameter if found in this prefix */
  overridePrefix?: InputMaybe<Scalars['String']>;
  roleArn: Scalars['String'];
};

export type AppConfigSigning = {
  enforceSignature: Scalars['Boolean'];
};

export type AppConfigSumSub = {
  /** basicLevelName: the name of the basic level kyc workflow in SumSub */
  basicLevelName: Scalars['String'];
  /** eddLevelName: the name of the extra due diligence level workflow in SumSub */
  eddLevelName: Scalars['String'];
  /** fullLevelName: the name of the full level kyc workflow in SumSub */
  fullLevelName: Scalars['String'];
};

/** AppEnvs are generic names of envs which contain one or more AppStages */
export enum AppEnvs {
  Dev = 'Dev',
  Prod = 'Prod',
}

/**
 * AppStages are specific stages of the App and it's deployment
 * WARNING! Changing these enum values can / will change the logical ID of deployed resouces, which can break deployments
 */
export enum AppStages {
  Dev = 'Dev',
  PreProd = 'PreProd',
  /** AppEnvs.Prod */
  Prod = 'Prod',
  /** AppEnvs.Dev */
  Review = 'Review',
  Sandbox = 'Sandbox',
  Test = 'Test',
}

export enum AssetBasis {
  AccountBased = 'AccountBased',
  UtxoBased = 'UtxoBased',
}

export type AuthEvent = {
  Email: Scalars['AWSEmail'];
  UserId: Scalars['UserID'];
};

export type AwsCaptchaApi = {
  key: Scalars['String'];
  src: Scalars['String'];
};

/** Badge: badge that can be earned */
export type Badge = {
  /** BadgeTypeID: identifies the type of this badge */
  BadgeTypeID: Scalars['BadgeTypeID'];
  /** Difficulty: difficulty of the badge */
  Difficulty: Scalars['Int'];
  /** QuestID: identifies a quest granting this badge */
  QuestID?: Maybe<Scalars['QuestID']>;
};

export enum BankAccountType {
  /**
   * Current: is an account that is used for everyday transactions.
   * It is also known as a checking account.
   */
  Current = 'Current',
  /** Savings: account used to earn interest on easily accessible cash */
  Savings = 'Savings',
}

export enum BankingSystem {
  /**
   * Fedwire: the BankCode identifies the bank through the routing number (within
   * the USA). The AccountNumber is the bank account identifier and is of
   * arbitrary length and format depending on the bank where the account is at.
   */
  Fedwire = 'Fedwire',
  /** Local: system local to a country. Banking channels of the country define the scheme. If a country has multiple systems, avoid using this. */
  Local = 'Local',
  /**
   * Sepa: the AccountNumber alone identifies the country, bank and account
   * according to the IBAN standard.
   */
  Sepa = 'Sepa',
  /**
   * SortCode: the BankCode identifies the bank/branch through the sort code
   * (6 digits) and the AccountNumber identifies the bank account number
   * (8 digits). The account number can start with 0.
   */
  SortCode = 'SortCode',
  /**
   * Swift: the BankCode identifies the bank (and branch where appropriate)
   * according to the SWIFT network stadards. The AccountNumber identifies the
   * account according to the local standards. For example, in the USA this
   * would an Account Number and in some EU countries this would be the IBAN.
   */
  Swift = 'Swift',
}

/** BotData: network traffic data for suspected bots */
export type BotData = {
  /** CountryValue: honeypot field value */
  CountryValue?: Maybe<Scalars['String']>;
  /**
   * IPCountry: Cloundfront country
   * See: https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/using-cloudfront-headers.html
   */
  IPCountry?: Maybe<Scalars['CountryCode']>;
  /**
   * IPRoute: X-Forwarded-For request header
   * See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-For
   */
  IPRoute?: Maybe<Scalars['String']>;
};

export type CardIssuerNotification = {
  /** Active: is this notification currently active */
  Active: Scalars['Boolean'];
  /** IssuerName: name of the card issuer */
  IssuerName: Scalars['String'];
  /** Reason: notification reason */
  Reason: CardIssuerNotificationReason;
};

export type CardIssuerNotificationInput = {
  /** IssuerName: name of the card issuer */
  IssuerName: Scalars['String'];
};

export enum CardIssuerNotificationReason {
  CreditCardPaymentsFailing = 'CreditCardPaymentsFailing',
  HsbcPaymentsFailing = 'HsbcPaymentsFailing',
}

export type Channel = {
  /** Country: The supported country of the channel */
  Country: Scalars['CountryCode'];
  /** CreatedAt: The date the channel was created */
  CreatedAt: Scalars['AWSDateTime'];
  /** CurrencyIndex: Currency index primary key. Formatted as FiatCurrency/Country/Direction */
  CurrencyIndex?: Maybe<Scalars['String']>;
  /** CurrencyIndexSk: Currency index sort key. Formatted as ChannelType/PaymentMethodType */
  CurrencyIndexSk?: Maybe<Scalars['String']>;
  /** Direction: The direction of the channel */
  Direction: TransactionDirection;
  /** Enabled: Whether channel is enabled */
  Enabled: Scalars['Boolean'];
  /** Expiry: The date the channel expired. A channel is expired when a significant change is introduced or when the channel is no longer supported. */
  Expiry?: Maybe<Scalars['AWSDateTime']>;
  /** FeeConfig: The fee configurations for using the channel */
  FeeConfig: Array<ChannelFeeConfig>;
  /** FiatCurrency: The fiat currency of the channel */
  FiatCurrency: FiatCurrencyCode;
  /** FinService: The financial service provider of the channel. */
  FinService: FinService;
  /** ID: UUID for the channel. */
  ID: Scalars['UUID'];
  /** LimitConfig: The limits for this channel */
  LimitConfig: ChannelLimitConfig;
  /** MaxProcessingSeconds: The maximum time it takes to process a transaction through the channel */
  MaxProcessingSeconds: Scalars['Int'];
  /** PaymentMethodCategory: The payment method category. */
  PaymentMethodCategory: PaymentMethodCategory;
  /** PaymentMethod: The payment method type. */
  PaymentMethodType: PaymentMethodType;
  /** ProcessingSeconds: The time it takes to process a transaction through the channel */
  ProcessingSeconds: Scalars['Int'];
};

export type ChannelConfig = {
  /** CountryConfig: list of currency and country configuration options */
  CountryConfig: Array<CountryConfig>;
  /** CreatedAt: The date the channel was created */
  CreatedAt: Scalars['AWSDateTime'];
  /** Direction: The direction of the channel */
  Direction: TransactionDirection;
  /** Enabled: Whether channel is enabled */
  Enabled: Scalars['Boolean'];
  /** FeeConfig: The fee configurations for using the channel */
  FeeConfig: Array<ChannelFeeConfig>;
  /** FiatCurrency: The fiat currency of the channel */
  FiatCurrency: FiatCurrencyCode;
  /** FinService: The financial service provider of the channel. */
  FinService: FinService;
  /** ID: UUID for the channel config */
  ID: Scalars['UUID'];
  /** LimitConfig: The limits for this channel */
  LimitConfig: ChannelLimitConfig;
  /** MaxProcessingSeconds: The maximum time it takes to process a transaction through the channel */
  MaxProcessingSeconds: Scalars['Int'];
  /** PaymentMethod: The payment method type. */
  PaymentMethodType: PaymentMethodType;
  /** ProcessingSeconds: The time it takes to process a transaction through the channel */
  ProcessingSeconds: Scalars['Int'];
};

export type ChannelFeeConfig = {
  /** FeeMin: The minimum fee charged for using the channel */
  FeeMin: Scalars['Decimal'];
  /** FeePct: The percentage fee charged for using the channel */
  FeePct?: Maybe<Scalars['Decimal']>;
  /** FeeType: The type of fee charged for using the channel */
  FeeType: FeeType;
  /** FiatCurrencyCode: The fiat currency code of the fee */
  FiatCurrencyCode: FiatCurrencyCode;
};

export type ChannelLimitConfig = {
  /** FiatCurrencyCode: The fiat currency code of the limits */
  FiatCurrencyCode: FiatCurrencyCode;
  /** MaxLimit: The maximum amount that can be sent through the channel */
  MaxLimit: Scalars['Decimal'];
  /** MinLimit: The minimum amount that can be sent through the channel */
  MinLimit: Scalars['Decimal'];
};

export enum CheckoutStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Settled = 'Settled',
}

export enum CkoMetadataType {
  admin_user_ids = 'admin_user_ids',
  compliance_reason = 'compliance_reason',
  reverses = 'reverses',
}

export enum CkoWebhookType {
  dispute_canceled = 'dispute_canceled',
  dispute_evidence_required = 'dispute_evidence_required',
  dispute_expired = 'dispute_expired',
  dispute_lost = 'dispute_lost',
  dispute_resolved = 'dispute_resolved',
  dispute_won = 'dispute_won',
  payment_approved = 'payment_approved',
  payment_authentication_failed = 'payment_authentication_failed',
  payment_canceled = 'payment_canceled',
  payment_capture_declined = 'payment_capture_declined',
  payment_captured = 'payment_captured',
  payment_declined = 'payment_declined',
  payment_expired = 'payment_expired',
  payment_pending = 'payment_pending',
  payment_refund_declined = 'payment_refund_declined',
  payment_refunded = 'payment_refunded',
  payment_void_declined = 'payment_void_declined',
  payment_voided = 'payment_voided',
  payout_declined = 'payout_declined',
  payout_paid = 'payout_paid',
}

/** Claim: user claim input */
export type ClaimInput = {
  /** Code: claim code */
  Code: Scalars['String'];
};

export type ClaimedPromotion = {
  /** Claims: IDs and amounts for the transactions / orders for which a promotion was applied against. */
  Claims: Array<PromotionClaim>;
  /** PromoID: ID of the promotion that was used */
  PromoID: Scalars['PromoID'];
  /** UsedAmount: Amount of the promotion that was used */
  UsedAmount: FiatAmount;
  /** UserID: ID of the user that claimed the promotion */
  UserID: Scalars['UserID'];
  /** Version: version to increment when updating ClaimedPromotion */
  Version: Scalars['Int'];
};

export enum ComparisonOperator {
  EQ = 'EQ',
  GTEQ = 'GTEQ',
  LTEQ = 'LTEQ',
}

export type ComplianceRefundInput = {
  PaymentID: Scalars['String'];
  RetoolID: Scalars['String'];
};

export type ComplianceRefundResponse = {
  RefundID: Scalars['UUID'];
};

export type CookieConsent = {
  advertising?: Maybe<Scalars['Boolean']>;
  functional: Scalars['Boolean'];
  marketingAndAnalytics?: Maybe<Scalars['Boolean']>;
};

export type CookieConsentInput = {
  advertising?: InputMaybe<Scalars['Boolean']>;
  functional: Scalars['Boolean'];
  marketingAndAnalytics?: InputMaybe<Scalars['Boolean']>;
};

export type CoreCurrencyNetworkConfiguration = {
  /** assetBasis: basis of this currency, which can be UTXO based or Account based. Only set if considered relevant */
  assetBasis?: InputMaybe<AssetBasis>;
  /**
   * assetID: how to identify this asset on the network it runs on. For ethereum
   * based tokens it will be the address contract.
   */
  assetID?: InputMaybe<Scalars['String']>;
  /** fireblocksID: is the ID of this currency in the fireblocks API */
  fireblocksID: Scalars['String'];
  /**
   * precision: how many decimal places this currency supports. For Ethereum based
   * tokens this is defined by the smart contract.
   */
  precision: Scalars['Int'];
};

/** CountLimit: A limit for the number of transactions over a time period */
export type CountLimit = {
  /** Limit: total number of transactions */
  Limit: Scalars['Int'];
  /** Usage: used number of transactions */
  Usage?: Maybe<Scalars['Int']>;
};

export type CounterpartyAddressInput = {
  City: Scalars['String'];
  Country: Scalars['CountryCode'];
  PostCode: Scalars['String'];
  Street: Scalars['String'];
};

export type CounterpartyInput = {
  AccountNo?: InputMaybe<Scalars['String']>;
  Address?: InputMaybe<CounterpartyAddressInput>;
  BankCountry: Scalars['CountryCode'];
  Bic?: InputMaybe<Scalars['String']>;
  BsbCode?: InputMaybe<Scalars['String']>;
  Clabe?: InputMaybe<Scalars['String']>;
  CompanyName: Scalars['String'];
  Currency: FiatCurrencyCode;
  Iban?: InputMaybe<Scalars['String']>;
  Ifsc?: InputMaybe<Scalars['String']>;
  RoutingNumber?: InputMaybe<Scalars['String']>;
  SortCode?: InputMaybe<Scalars['String']>;
};

export type CountryConfig = {
  /** Country: The supported country of the channel */
  Country: Scalars['CountryCode'];
};

export type CreateApiKeyInput = {
  /** Expires: Optional expiration date for the API key. If not provided, the key does not expire. */
  Expires?: InputMaybe<Scalars['AWSDateTime']>;
  /** Label: A unique label for the API key. */
  Label: Scalars['String'];
  /** PublicKey: base64 encoded X.509 SubjectPublicKeyInfo */
  PublicKey?: InputMaybe<Scalars['String']>;
  /** Signature: signature with user's NonCustodyKey, of the form v1/DateTime/base64(sign(ApiSigningKey/DateTime/PublicKey)) */
  Signature?: InputMaybe<Scalars['String']>;
};

/** CryptoAmount: amount in cryptocurrency */
export type CryptoAmount = {
  /** Amount: amount of cryptocurrency */
  Amount: Scalars['Decimal'];
  /** Currency: cryptocurrency the amount is for */
  Currency: CurrencyCode;
  /** FetchedAt: the time when the rate was fetched */
  FetchedAt?: Maybe<Scalars['AWSDateTime']>;
  /** Price: price of the cryptocurrency in fiat */
  Price?: Maybe<Scalars['Decimal']>;
};

/** CurrencyCode: the currency codes e.g. BTC / ETH */
export enum CurrencyCode {
  /** BTC: Bitcoin currency */
  BTC = 'BTC',
  /** BTC_TEST: Testnet Bitcoin */
  BTC_TEST = 'BTC_TEST',
  /** ETH: Etherum currency */
  ETH = 'ETH',
  /** ETH_TEST_SEPOLIA: Testnet Ethereum (SEPOLIA) */
  ETH_TEST_SEPOLIA = 'ETH_TEST_SEPOLIA',
  /** MATIC: Matic currency */
  MATIC = 'MATIC',
  /** MATIC_TEST: Testnet Matic */
  MATIC_TEST = 'MATIC_TEST',
  /** NOAH: Noah's currency */
  NOAH = 'NOAH',
  /** TRX: Tron currency */
  TRX = 'TRX',
  /** TRX_TEST: Testnet Tron */
  TRX_TEST = 'TRX_TEST',
  /** USDC: USD Coin currency */
  USDC = 'USDC',
  /** USDC_TEST: Testnet USD Coin */
  USDC_TEST = 'USDC_TEST',
  /** USDT: Tether USD currency */
  USDT = 'USDT',
  /** USDT_TEST: Testnet Tether USD */
  USDT_TEST = 'USDT_TEST',
}

/** CurrencyDisplayType: the type of currency used to display in the app */
export enum CurrencyDisplayType {
  Crypto = 'Crypto',
  Fiat = 'Fiat',
}

/** CurrencyUnit: the units a currency can be displayed in e.g. SATS / GWEI */
export enum CurrencyUnit {
  /** BITS: A BTC unit - 1 BTC = 1,000,000 BITS */
  BITS = 'BITS',
  /** Default: Uses the default unit of the Crypto currency */
  Default = 'Default',
  /** GWEI: An ETH unit - 1 ETH = 10^9 GWEI */
  GWEI = 'GWEI',
  /** SATS: A BTC unit - 1 BTC = 100,000,000 SATS */
  SATS = 'SATS',
  /** WEI: An ETH unit - 1 ETH = 10^18 WEI */
  WEI = 'WEI',
}

export type Customer = {
  /** ComplianceState: details a user's compliance status */
  ComplianceState?: Maybe<UserComplianceState>;
  Created: Scalars['AWSDateTime'];
  CreationSource: CustomerCreationSource;
  CustomerID: Scalars['CustomerID'];
  DateOfBirth: Scalars['AWSDate'];
  FullName: FullName;
  Identities?: Maybe<Array<CustomerIdentity>>;
  PrimaryResidence: StreetAddress;
  UserID: Scalars['UserID'];
};

export enum CustomerCreationSource {
  Api = 'Api',
}

export type CustomerIdentity = {
  ExpiryDate?: Maybe<Scalars['AWSDate']>;
  IDNumber: Scalars['String'];
  IDType: IdentityType;
  IssuedDate?: Maybe<Scalars['AWSDate']>;
  IssuingCountryCode: Scalars['CountryCode'];
};

export type CustomerIdentityInput = {
  ExpiryDate?: InputMaybe<Scalars['AWSDate']>;
  IDNumber: Scalars['String'];
  IDType: IdentityType;
  IssuedDate?: InputMaybe<Scalars['AWSDate']>;
  IssuingCountryCode: Scalars['CountryCode'];
};

export type CustomerInput = {
  /** CustomerID: the unique identifier of this customer */
  CustomerID: Scalars['String'];
};

export type CustomersPage = {
  items?: Maybe<Array<Customer>>;
  nextToken?: Maybe<Scalars['String']>;
};

/** DDBTableNames: an enum describing the tables that are created in DynamoDB */
export type DdbTableNames = {
  accounts: Scalars['DDBTableName'];
  adminusers: Scalars['DDBTableName'];
  apikeys2: Scalars['DDBTableName'];
  badges: Scalars['DDBTableName'];
  cardissuernotifications: Scalars['DDBTableName'];
  channelconfig: Scalars['DDBTableName'];
  channels: Scalars['DDBTableName'];
  /** checkoutdocumets: (CORE-619) Stores webhooks from Checkout(merchant) */
  checkoutdocuments: Scalars['DDBTableName'];
  checkoutsessions2: Scalars['DDBTableName'];
  ckopayoutstatuses: Scalars['DDBTableName'];
  compliancerequests: Scalars['DDBTableName'];
  customers: Scalars['DDBTableName'];
  depositaddresses: Scalars['DDBTableName'];
  depositorderids: Scalars['DDBTableName'];
  earnedbadges: Scalars['DDBTableName'];
  fiatpaymentmethods: Scalars['DDBTableName'];
  fiatpayments: Scalars['DDBTableName'];
  fireblockswebhooks: Scalars['DDBTableName'];
  formsessions: Scalars['DDBTableName'];
  fundingbalances: Scalars['DDBTableName'];
  liquidityorders: Scalars['DDBTableName'];
  manualramppayments: Scalars['DDBTableName'];
  marketingcodes: Scalars['DDBTableName'];
  marketprices: Scalars['DDBTableName'];
  noahpoints: Scalars['DDBTableName'];
  paymentrequests: Scalars['DDBTableName'];
  policyorders: Scalars['DDBTableName'];
  promotionclaims: Scalars['DDBTableName'];
  promotions: Scalars['DDBTableName'];
  pubsubhandledevents: Scalars['DDBTableName'];
  questcompletions: Scalars['DDBTableName'];
  quests: Scalars['DDBTableName'];
  questtaskstatuses: Scalars['DDBTableName'];
  remiteepayoutstatuses: Scalars['DDBTableName'];
  revolutaccounts: Scalars['DDBTableName'];
  rulerefs: Scalars['DDBTableName'];
  rules: Scalars['DDBTableName'];
  statemachinesuspendstates: Scalars['DDBTableName'];
  transactions: Scalars['DDBTableName'];
  transactionsmetadata: Scalars['DDBTableName'];
  userconsent: Scalars['DDBTableName'];
  usernames: Scalars['DDBTableName'];
  users: Scalars['DDBTableName'];
  uservault: Scalars['DDBTableName'];
  webhooksubscriptions: Scalars['DDBTableName'];
  whitelist: Scalars['DDBTableName'];
  withdrawrequests: Scalars['DDBTableName'];
};

export type DeleteApiKeyInput = {
  /** KeyHash: The API key hash to delete. */
  KeyHash: Scalars['String'];
  /** Label: A label of the key to delete. */
  Label: Scalars['String'];
};

/** DepositAddress: address where user can directly deposit funds */
export type DepositAddress = {
  /**
   * AccountID: the ID of the account this balance belongs to, of the form <UserID>/<CurrencyCode>/<Type>
   *
   * @deprecated New deposit addresses use UserID instead
   */
  AccountID?: Maybe<Scalars['AccountID']>;
  /** AddressFormat: format of the address */
  AddressFormat: AddressFormat;
  /** CurrencyCode: the currency code of this account's base currency e.g. BTC / ETH */
  CurrencyCode: CurrencyCode;
  /** DestinationAddress: address user can deposit funds to */
  DestinationAddress: DestinationAddress;
  /** UserID: identifies the owner of this deposit address */
  UserID: Scalars['UserID'];
  /** VaultAccountID: ID of the Fireblocks vault account */
  VaultAccountID: Scalars['ID'];
};

/**
 * DepositAddressRequest: querying a deposit address for a specific network in the account create input.
 * If Create bool is set the deposit address will be created if one does not exists.
 */
export type DepositAddressRequest = {
  Create: Scalars['Boolean'];
  Network: Network;
};

/** DepositAddressesIndexedFields: index fields on ledger deposit addresses tables */
export enum DepositAddressesIndexedFields {
  AccountID = 'AccountID',
  DestinationAddress = 'DestinationAddress',
}

/** DepositAddressesInput: GraphQL input to obtain deposit addresses for a user given currency and network (UserID will come from JWT) */
export type DepositAddressesInput = {
  /** CurrencyCode: the currency code of the account's base currency e.g. BTC / ETH */
  CurrencyCode: CurrencyCode;
  /** Network: the network for the currency to obtain deposit address. */
  Network: Network;
};

export type DepositDestinationTrigger = Trigger & {
  Amount: Scalars['Decimal'];
  CryptoCurrency: CurrencyCode;
  CustomerID?: Maybe<Scalars['CustomerID']>;
  DepositAddress: DepositAddress;
  Network?: Maybe<Network>;
  RefundAddress: DestinationAddress;
  Type: TriggerType;
};

export type DepositSourceTrigger = Trigger & {
  Conditions: Array<DepositSourceTriggerCondition>;
  CustomerID: Scalars['CustomerID'];
  SourceAddress: Scalars['String'];
  Type: TriggerType;
};

export type DepositSourceTriggerCondition = {
  AmountConditions: Array<AmountCondition>;
  CryptoCurrency: CurrencyCode;
  Network?: Maybe<Network>;
};

/** DestinationAddress: the end location of a transaction */
export type DestinationAddress = {
  /** Address: the wallet address of the transaction */
  Address: Scalars['Address'];
  /** Ref: Destination tag for XRP, used as memo for EOS/XLM */
  Ref?: Maybe<Scalars['AddressRef']>;
};

/** DestinationAddressInput: single use address */
export type DestinationAddressInput = {
  /** Address: address for transfer */
  Address: Scalars['Address'];
  /** Ref: Destination tag for XRP, used as memo for EOS/XLM */
  Ref?: InputMaybe<Scalars['AddressRef']>;
};

export enum DetailType {
  AppSyncEvent = 'AppSyncEvent',
  InboundEvent = 'InboundEvent',
  PubSubEvent = 'PubSubEvent',
  WebhookEvent = 'WebhookEvent',
}

/** EarnedBadge: badge that user has earned */
export type EarnedBadge = {
  /** BadgeTypeID: identifies the type of this badge */
  BadgeTypeID: Scalars['BadgeTypeID'];
  /** Difficulty: difficulty of the quest granting this badge */
  Difficulty: Scalars['Int'];
  /** Earned: date when this badge was earned */
  Earned: Scalars['AWSDateTime'];
  /** Opens: date from which the badge is displayed to users */
  Opens: Scalars['AWSDateTime'];
  /** QuestID: identifies the quest ID that granted this badge */
  QuestID?: Maybe<Scalars['QuestID']>;
  /** UserID: identifies the owner of this badge */
  UserID: Scalars['UserID'];
};

/** EntityAccountID: ID of a reserved Account. */
export enum EntityAccountId {
  /**
   * System: Singular black hole account that applies to all currencies.
   *
   * NOAH tokens can be minted from this account and burned by sending to this account.
   */
  System = 'System',
}

export enum EnvVarNames {
  /** ACCOUNTS_BUCKET_NAME: bucket name of json qldb accounts table backup */
  ACCOUNTS_BUCKET_NAME = 'ACCOUNTS_BUCKET_NAME',
  /** AWS_APPCONFIG_EXTENSION_LOG_LEVEL: see https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-integration-lambda-extensions.html */
  AWS_APPCONFIG_EXTENSION_LOG_LEVEL = 'AWS_APPCONFIG_EXTENSION_LOG_LEVEL',
  /** AWS_APPCONFIG_EXTENSION_POLL_INTERVAL_SECONDS: see https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-integration-lambda-extensions.html */
  AWS_APPCONFIG_EXTENSION_POLL_INTERVAL_SECONDS = 'AWS_APPCONFIG_EXTENSION_POLL_INTERVAL_SECONDS',
  /** AWS_APPCONFIG_EXTENSION_PREFETCH_LIST: see https://docs.aws.amazon.com/appconfig/latest/userguide/appconfig-integration-lambda-extensions.html */
  AWS_APPCONFIG_EXTENSION_PREFETCH_LIST = 'AWS_APPCONFIG_EXTENSION_PREFETCH_LIST',
  /** BALANCES_BUCKET_NAME: bucket name of json qldb balances table backup */
  BALANCES_BUCKET_NAME = 'BALANCES_BUCKET_NAME',
  /** EVENT_BUS_ARN: arn of an event bus to send events to */
  EVENT_BUS_ARN = 'EVENT_BUS_ARN',
  /** REWARDS_BUCKET_NAME: bucket name of json qldb rewards table backup */
  REWARDS_BUCKET_NAME = 'REWARDS_BUCKET_NAME',
  /** STATE_MACHINE_ARN: arn of a state machine that can be started */
  STATE_MACHINE_ARN = 'STATE_MACHINE_ARN',
  /** TRANSACTION_BUCKET_NAME: bucket name of json qldb transactions table backup */
  TRANSACTIONS_BUCKET_NAME = 'TRANSACTIONS_BUCKET_NAME',
  /** WITHDRAW_ORDERS_BUCKET_NAME: bucket name of qldb withdraworders table backup */
  WITHDRAW_ORDERS_BUCKET_NAME = 'WITHDRAW_ORDERS_BUCKET_NAME',
}

export type ErrorCatch = {
  /** Error: error message */
  Error: Scalars['String'];
};

export type EstimateBalanceInput = {
  TargetAsset: Scalars['AssetID'];
};

export type EstimateBalanceResponse = {
  Available: Scalars['Decimal'];
  Total: Scalars['Decimal'];
};

/** EventBridgeInput: Describes the schema of an event expected by EventBridge. */
export type EventBridgeInput = {
  /** Detail: the raw event as a json string. */
  Detail: Scalars['AWSJSON'];
  /** DetailType: a string enum describing the event. */
  DetailType: DetailType;
  /** EventBusName: the name of the target event bus (generated by cdk). */
  EventBusName: Scalars['String'];
  /** Source: the source of the event - used for routing events in EventBridge. */
  Source: EventSource;
};

/**
 * EventBridgeOutput: Do not modify - set by AWS. Describes the full type that is sent from EventBridge to its consumers.
 * EventBridge automatically appends these properties and you can see them in the relevant CloudWatch logs.
 * Note: it is possible to filter some of the fields of the payload in the `Detail` field but so far, we don't.
 */
export type EventBridgeOutput = {
  /** ID: Unique ID of the event (generated by AWS). */
  ID: Scalars['EventID'];
  /** Region: The AWS Region of the originating event. */
  Region: Scalars['String'];
  /** Resources: currently unused. */
  Resources: Array<Scalars['String']>;
  /** Time: RFC3339 timestamp of the received event. */
  Time: Scalars['AWSDateTime'];
  /** Version: of the event, defaults to '0'. */
  Version: Scalars['String'];
};

/** EventIndexedFields: index fields on ledger events tables (e.g. fireblocks & moonpay) */
export enum EventIndexedFields {
  Hash = 'Hash',
  ID = 'ID',
  PublicID = 'PublicID',
}

/** EventOrigin: Where did the event originate from */
export enum EventOrigin {
  DynamoDbFiatPayment = 'DynamoDbFiatPayment',
  LedgerTransaction = 'LedgerTransaction',
  LedgerWithdrawOrder = 'LedgerWithdrawOrder',
}

export enum EventSource {
  CkoWebhook = 'CkoWebhook',
  FireblocksWebhook = 'FireblocksWebhook',
  LndInvoicesWebhook = 'LndInvoicesWebhook',
  LndPaymentsWebhook = 'LndPaymentsWebhook',
  NoahEventPub = 'NoahEventPub',
  NoahUser = 'NoahUser',
  OryWebhook = 'OryWebhook',
  RevolutWebhook = 'RevolutWebhook',
  SardineWebhook = 'SardineWebhook',
  SigningWebhook = 'SigningWebhook',
  SumSubWebhook = 'SumSubWebhook',
}

export enum ExecutionEnv {
  Bitcoin = 'Bitcoin',
  Evm = 'Evm',
}

/** ExternalIntegration: external system that Noah is integrated with */
export enum ExternalIntegration {
  ApplePay = 'ApplePay',
  Cko = 'Cko',
  Coingecko = 'Coingecko',
  EthRpc = 'EthRpc',
  Fireblocks = 'Fireblocks',
  Flutterwave = 'Flutterwave',
  Novu = 'Novu',
  Onafriq = 'Onafriq',
  Ory = 'Ory',
  Remitee = 'Remitee',
  Revolut = 'Revolut',
  Sardine = 'Sardine',
  Scorechain = 'Scorechain',
  Segment = 'Segment',
  SumSub = 'SumSub',
  WebhookSubscriber = 'WebhookSubscriber',
  Woorton = 'Woorton',
}

export type FailPaymentInput = {
  ID: Scalars['DynamoID'];
};

export type FailPaymentResponse = {
  Status: PaymentStatus;
};

export type FailureStep = {
  /** Source: source of the failure */
  Source: TransactionStepSource;
  /** Step: step of the failure */
  Step: ReconciliationResult;
};

/**
 * Feature: Feature available to user.
 * If adding a new feature, please verify whether it should be enabled for suspended users and add here: apps/be/core/pkg/feature/flag.go
 */
export enum Feature {
  /** Bitrefill: Buy from Bitrefill. */
  Bitrefill = 'Bitrefill',
  /** Business: features reserved for business users. */
  Business = 'Business',
  /** Buy: Buy cryptocurrency via channels. */
  Buy = 'Buy',
  /** Deposit: Deposit currency to account. */
  Deposit = 'Deposit',
  /** Kyc: Register Know Your Customer details. */
  Kyc = 'Kyc',
  /** LnInvoice: Create a lightning invoice. */
  LnInvoice = 'LnInvoice',
  /** LnPayment: Make a lightning payment. */
  LnPayment = 'LnPayment',
  /** Notifications: Receives notifications (account activity, transactions etc.). */
  Notifications = 'Notifications',
  /** Pin: Register a secure PIN. */
  Pin = 'Pin',
  /** Sell: Sell cryptocurrency via channels. */
  Sell = 'Sell',
  /** Sumsub: Register Know Your Customer details with Sumsub. */
  Sumsub = 'Sumsub',
  /** UIPromotions: display in-app promotional & marketing material */
  UIPromotions = 'UIPromotions',
  /** UIRewards: display in-app access to rewards / quests etc. */
  UIRewards = 'UIRewards',
  /** Withdraw: Withdraw currency from account. */
  Withdraw = 'Withdraw',
}

/** FeatureFlag: Feature's availability for a user. */
export type FeatureFlag = {
  /** Currencies: A list of currencies for which this feature applies to. */
  Currencies?: Maybe<Array<CurrencyCode>>;
  /** Enabled: Can the user use this feature. */
  Enabled: Scalars['Boolean'];
  /** Feature: Feature which availability the flag controls. */
  Feature: Feature;
  /** Networks: A list of networks for which this feature applies to. */
  Networks?: Maybe<Array<Network>>;
  /** Reason: Reason for the feature's status. */
  Reason?: Maybe<Array<FeatureFlagReason>>;
};

export type FeatureFlagInput = {
  Currencies?: InputMaybe<Array<CurrencyCode>>;
  Enabled: Scalars['Boolean'];
  Feature: Feature;
  Networks?: InputMaybe<Array<Network>>;
  Reason?: InputMaybe<Array<FeatureFlagReason>>;
};

export enum FeatureFlagReason {
  /** BetaAccess: Founding members can access this feature. */
  BetaAccess = 'BetaAccess',
  /** GloballyDisabled: Feature is disabled for all users. */
  GloballyDisabled = 'GloballyDisabled',
  /** Kyc: KYC is required for this feature */
  Kyc = 'Kyc',
  /** Maintenance: Feature is in maintenance mode and disabled for all users. */
  Maintenance = 'Maintenance',
  /** RestrictedRegion: User's region is restricted */
  RestrictedRegion = 'RestrictedRegion',
  /** Suspended: account is suspended */
  Suspended = 'Suspended',
}

export enum FeeType {
  FinServiceFee = 'FinServiceFee',
  ServiceFee = 'ServiceFee',
}

/** FiatAmount: amount in fiat currency */
export type FiatAmount = {
  /** Amount: amount of fiat currency */
  Amount: Scalars['Decimal'];
  /** CryptoAmounts: amount converted to cryptocurrency in exchange rate */
  CryptoAmounts?: Maybe<Array<CryptoAmount>>;
  /** FetchedAt: the time when the rate was fetched */
  FetchedAt?: Maybe<Scalars['AWSDateTime']>;
  /** FiatCurrency: used fiat currency */
  FiatCurrency: FiatCurrencyCode;
  /** Price: price of the cryptocurrency in fiat */
  Price?: Maybe<Scalars['Decimal']>;
};

/** FiatAmount: amount in fiat currency */
export type FiatAmountCryptoAmountsArgs = {
  CurrencyCodes?: InputMaybe<Array<CurrencyCode>>;
};

/** FiatAmountInput: amount in fiat currency */
export type FiatAmountInput = {
  /** Amount: amount of fiat currency */
  Amount: Scalars['Decimal'];
  /** FetchedAt: the time when the rate was fetched */
  FetchedAt: Scalars['AWSDateTime'];
  /** Currency: used fiat currency */
  FiatCurrency: FiatCurrencyCode;
  /** Price: price of the cryptocurrency in fiat */
  Price: Scalars['Decimal'];
};

/** FiatCurrencyCode: fiat currency codes e.g. USD / GBP */
export enum FiatCurrencyCode {
  AED = 'AED',
  ARS = 'ARS',
  AUD = 'AUD',
  BDT = 'BDT',
  BHD = 'BHD',
  BMD = 'BMD',
  BRL = 'BRL',
  CAD = 'CAD',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CZK = 'CZK',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  HKD = 'HKD',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  JPY = 'JPY',
  KRW = 'KRW',
  KWD = 'KWD',
  LKR = 'LKR',
  MMK = 'MMK',
  MXN = 'MXN',
  MYR = 'MYR',
  NGN = 'NGN',
  NOK = 'NOK',
  NZD = 'NZD',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  RUB = 'RUB',
  SAR = 'SAR',
  SEK = 'SEK',
  SGD = 'SGD',
  THB = 'THB',
  TRY = 'TRY',
  TWD = 'TWD',
  UAH = 'UAH',
  USD = 'USD',
  VEF = 'VEF',
  VND = 'VND',
  ZAR = 'ZAR',
}

/** FiatPayment: reference of an incoming or outgoing fiat payment */
export type FiatPayment = {
  /** Channel: The channel used for the payment */
  Channel?: Maybe<Channel>;
  /** ComplianceData: Compliance metadata for the payment */
  ComplianceData?: Maybe<PaymentComplianceData>;
  /** FailureCause: The reason why the payment failed */
  FailureCause?: Maybe<NoahError>;
  /**
   * FeeFiatAmount: How much fiat fee applies to this payment. When debiting the
   * user this amount is included in the PaymentAmount. When crediting the user
   * this amount is excluded from the PaymentAmount.
   */
  FeeFiatAmount: Scalars['Decimal'];
  /**
   * FiatPaymentMethod: The state of the payment method at the time the payment
   * was created. This might differ from the current state.
   */
  FiatPaymentMethod?: Maybe<FiatPaymentMethod>;
  /** Frontend: Which frontend (not necessarily UI) initiated this fiat payment. */
  Frontend?: Maybe<FiatPaymentFrontend>;
  /** LiquidityOrderID: ID of liquidity order used to offset this payment, empty if not yet offset */
  LiquidityOrderID?: Maybe<Scalars['String']>;
  /** OrderCurrency: Currency of the order */
  OrderCurrency: CurrencyCode;
  /** PaymentAmount: Fiat amount that has been received / sent */
  PaymentAmount: FiatAmount;
  /** PaymentID: ID of the payment reference */
  PaymentID: Scalars['String'];
  /** PaymentStatus: Status of the payment */
  PaymentStatus: FiatPaymentStatus;
  /** PaymentType: Direction of the payment */
  PaymentType: TransactionDirection;
  /** Refunds: refunds of this payment */
  Refunds?: Maybe<Array<FiatPaymentRefund>>;
  /** RefundsVersion: version of the refunds field */
  RefundsVersion?: Maybe<Scalars['Int']>;
  /** RequestTime: timestamp when the request for the funds was made */
  RequestTime: Scalars['AWSDateTime'];
  /** TokenizationSource: source of the payment tokenization */
  TokenizationSource?: Maybe<FiatPaymentTokenizationSource>;
  /** UserID: ID of the user purchasing crypto */
  UserID: Scalars['UserID'];
};

export type FiatPaymentAppleSessionInput = {
  ValidationURL: Scalars['AWSURL'];
};

export type FiatPaymentAppleSessionResponse = {
  MerchantSession: Scalars['String'];
};

export type FiatPaymentBank = FiatPaymentMethodDetails & {
  /** AccountCurrency: what is this currency this account holds. */
  AccountCurrency: FiatCurrencyCode;
  /**
   * AccountNumber: identifies the bank account under a certain system. May
   * contain letters and even special characters. This is the key way to identify
   * the account but in some systems it might not be enough on its own.
   */
  AccountNumber: Scalars['String'];
  /** AccountType: the type of the bank account. */
  AccountType?: Maybe<BankAccountType>;
  /**
   * BankCode: identifies the bank under a certain system. This can be
   * significantly different for each system but ultimately represents the bank
   * holding the account. May be optional for some banking systems.
   */
  BankCode?: Maybe<Scalars['String']>;
  /**
   * BankCountry: the country where the bank is officially registered in.
   * This cannot be reliably derived from:
   *   * the account currency as some banks allow it's users to hold accounts in
   *   multiple currencies and some currencies are used in multiple countries.
   *   * the account holder address because some banks cater for foreign customers
   */
  BankCountry: Scalars['CountryCode'];
  /** BranchCode: identifies the branch of the bank where the account is held. */
  BranchCode?: Maybe<Scalars['String']>;
  /** Payout: payout estimation and raw data from the provider. */
  Payout: Payout;
  /** Reusable: indicates if the payment method can be used multiple times. */
  Reusable: Scalars['Boolean'];
  /**
   * System: the scheme to identify the recipient. Some systems require more data
   * than others and it often partially overlaps. Some systems may require very
   * unique data. The potential combinations are virtually unmaintainable if we
   * were to create separate types for each so we use a flat structure and this
   * field to indicate what should be the expected scheme. Validation should
   * happen at the application layer.
   */
  System: BankingSystem;
};

export type FiatPaymentBankSaveInput = {
  /** AccountCurrency: currency this account holds. */
  AccountCurrency: FiatCurrencyCode;
  /** AccountHolderDetails: account holder details */
  AccountHolderDetails?: InputMaybe<AccountHolderDetailsInput>;
  /**
   * AccountNumber: identifies the bank account under a certain system. May
   * contain letters and even special characters. This is the key way to identify
   * the account but in some systems it might not be enough on its own.
   */
  AccountNumber: Scalars['String'];
  /** AccountType: the type of the bank account. */
  AccountType?: InputMaybe<BankAccountType>;
  /**
   * BankCode: identifies the bank under a certain system. This can be
   * significantly different for each system but ultimately represents the bank
   * holding the account. May be optional for some banking systems.
   */
  BankCode?: InputMaybe<Scalars['String']>;
  /** BankCountry: the country where the bank is officially registered in. */
  BankCountry: Scalars['CountryCode'];
  /** BranchCode: identifies the branch of the bank where the account is held. */
  BranchCode?: InputMaybe<Scalars['String']>;
  /** Reusable: indicates if the payment method can be used multiple times. */
  Reusable: Scalars['Boolean'];
  /**
   * System: the scheme to identify the recipient. Some systems require more data
   * than others and it often partially overlaps. Some systems may require very
   * unique data. The potential combinations are virtually unmaintainable if we
   * were to create separate types for each so we use a flat structure and this
   * field to indicate what should be the expected scheme. Validation should
   * happen at the application layer.
   */
  System: BankingSystem;
};

/** FiatPaymentCard: a card payment method associated with a user */
export type FiatPaymentCard = FiatPaymentMethodDetails & {
  /** BillingAddress: the billing address for the payment method */
  BillingAddress: StreetAddress;
  /** Bin: the bank identification number of the card */
  Bin: Scalars['String'];
  /** Currency: currency in which a credit card issuer processes and bills the cardholder’s transactions. */
  Currency?: Maybe<FiatCurrencyCode>;
  /** ExpiryMonth: the expiry month of the card. Contains 1-2 characters */
  ExpiryMonth: Scalars['Int'];
  /** ExpiryYear: the expiry year of the card. Contains 4 characters */
  ExpiryYear: Scalars['Int'];
  /** Fingerprint: the fingerprint of the card */
  Fingerprint: Scalars['String'];
  /** Issuer: the issuer of the card */
  Issuer?: Maybe<Scalars['String']>;
  /**
   * IssuerCountry: The card issuer's country (two-letter ISO code).
   *
   * This field is required for new FiatPaymentCards. For existing cards, if this field is not present when read from the database, it must be retrieved and added.
   */
  IssuerCountry?: Maybe<Scalars['CountryCode']>;
  /** Last4: the last 4 digits of the card */
  Last4: Scalars['String'];
  /** Payout: payout estimation and raw data from the provider. */
  Payout: Payout;
  /** Reusable: indicates that the payment method can be reused */
  Reusable: Scalars['Boolean'];
  /** Scheme: the Scheme of the card */
  Scheme: FiatPaymentCardScheme;
};

export enum FiatPaymentCardScheme {
  Mastercard = 'Mastercard',
  Visa = 'Visa',
}

/** FiatPaymentDetailsInput: details of the payment being used in the request */
export type FiatPaymentDetailsInput = {
  /**
   * ID: ID of the payment corresponding to the type (token / instrumentID / paymentMethodID) etc if applicable.
   * Current types that require ID are CheckoutToken and CheckoutSourceID.
   */
  ID?: InputMaybe<Scalars['String']>;
  /** Type: type of the payment to use */
  Type: FiatPaymentType;
};

export enum FiatPaymentFrontend {
  HostedCheckout = 'HostedCheckout',
  NoahApp = 'NoahApp',
}

export type FiatPaymentIdentifier = FiatPaymentMethodDetails & {
  /** Currency: accepted currency. */
  Currency: FiatCurrencyCode;
  /** Identifier: account identifier. */
  Identifier: Scalars['String'];
  /** IdentifierType: type of account identifier in the payment system. */
  IdentifierType: PaymentIdentifierType;
  /** Payout: payout estimation and raw data from the provider. */
  Payout: Payout;
  /** Reusable: indicates if the payment method can be used multiple times. */
  Reusable: Scalars['Boolean'];
  /** System: payment system */
  System: IdentifierPaymentSystem;
};

export type FiatPaymentIdentifierInput = {
  /** AccountHolderDetails: account holder details */
  AccountHolderDetails?: InputMaybe<AccountHolderDetailsInput>;
  /** Currency: accepted currency. */
  Currency: FiatCurrencyCode;
  /** Identifier: account identifier. */
  Identifier: Scalars['String'];
  /** IdentifierType: type of account identifier in the payment system. */
  IdentifierType: PaymentIdentifierType;
  /** Reusable: indicates if the payment method can be used multiple times. */
  Reusable: Scalars['Boolean'];
  /** System: payment system */
  System: IdentifierPaymentSystem;
};

export type FiatPaymentInput = {
  /** CurrencyCode: the currency code of the purchase currency. */
  CurrencyCode: CurrencyCode;
  /**
   * Nonce: When provided we garantee that only one payment will ever be created
   * for the same Nonce. This can be used to safely retry payment requests.
   */
  Nonce?: InputMaybe<Scalars['Nonce']>;
  /** PaymentDetails: payment details for the payment. */
  PaymentDetails: FiatPaymentDetailsInput;
  /** Provider: provider to use for payment. */
  Provider: FiatPaymentProvider;
  /** RequestedAmount: fiat amount that user entered to buy. */
  RequestedAmount: FiatRequestedAmountInput;
  /** TokenizationSource: source of the payment tokenization */
  TokenizationSource: FiatPaymentTokenizationSource;
};

/** FiatPaymentIntegration: the integration of a payment method */
export type FiatPaymentIntegration = FiatPaymentIntegrationTokenized;

/** FiatPaymentIntegrationTokenized: integration where a token given is by a payment provider */
export type FiatPaymentIntegrationTokenized = {
  /** Provider: provider for the token */
  Provider: FiatPaymentMethodTokenProvider;
  /** Token: token for the payment method */
  Token: Scalars['String'];
};

export type FiatPaymentIntegrationTokenizedInput = {
  /** Provider: provider for the token */
  Provider: FiatPaymentMethodTokenProvider;
  /** Token: token for the payment method */
  Token: Scalars['String'];
};

/** FiatPaymentMethod: a payment method associated with a user */
export type FiatPaymentMethod = {
  /** AccountHolder: account holder details */
  AccountHolderDetails?: Maybe<AccountHolderDetails>;
  /** Country: the country of the payment method. */
  Country?: Maybe<Scalars['CountryCode']>;
  /** Created: the date and time the wallet item was created */
  Created: Scalars['AWSDateTime'];
  /** CustomerID: ID of the customer the Payment Method was created for */
  CustomerID?: Maybe<Scalars['CustomerID']>;
  /** Details: details of fiat payment method, such as last4 digits of card */
  Details: FiatPaymentMethodDetails;
  /**
   * DynamoID: the ID of the payment method that is composed of multiple parts.
   * For cards, it is [Card]/[Provider]/[Scheme]/[Fingerprint]
   */
  DynamoID: Scalars['DynamoID'];
  /** Integration: the integration of the payment method */
  Integration?: Maybe<FiatPaymentIntegration>;
  /** UserID: the ID of the user that owns the payment method */
  UserID: Scalars['UserID'];
};

export type FiatPaymentMethodDeleteInput = {
  DynamoID: Scalars['DynamoID'];
};

/** FiatPaymentMethodDetails: details of fiat payment method, such as last4 digits of card */
export type FiatPaymentMethodDetails = {
  /** Payout: payout estimation and raw data from the provider. */
  Payout: Payout;
  /** Reusable: indicates that the payment method can be reused */
  Reusable: Scalars['Boolean'];
};

export enum FiatPaymentMethodTokenProvider {
  Checkout = 'Checkout',
}

export type FiatPaymentMethodTokenizedCardSaveInput = {
  /** Provider: provider for the token */
  Provider: FiatPaymentMethodTokenProvider;
  /** SaveForFutureUse: whether the payment method should be saved for future use */
  SaveForFutureUse: Scalars['Boolean'];
  /** Token: token for the payment method */
  Token: Scalars['String'];
};

export type FiatPaymentMethodUpdateInput = {
  /** BillingAddress: New billing address */
  BillingAddress: StreetAddressInput;
  /** DynamoID: DynamoID of the payment method that is being updated. */
  DynamoID: Scalars['DynamoID'];
};

export type FiatPaymentMethodWalletCardSaveInput = {
  /** Details: details of fiat payment method, such as last4 digits of card */
  Details: FiatPaymentWalletCardInput;
  /** Integration: the integration of the payment method */
  Integration: FiatPaymentIntegrationTokenizedInput;
};

/** FiatPaymentMethods: a list of payment methods associated with a user */
export type FiatPaymentMethods = {
  Items?: Maybe<Array<FiatPaymentMethod>>;
};

export type FiatPaymentMethodsInput = {
  /** CustomerID: ID of the customer the Payment Method was created for */
  CustomerID?: InputMaybe<Scalars['CustomerID']>;
};

/** @deprecated Use PaymentProvider enum instead */
export enum FiatPaymentProvider {
  Checkout = 'Checkout',
}

export type FiatPaymentRefund = {
  /** RefundAmount: amount to refund, may be equal or less than PaymentAmount */
  RefundAmount: FiatAmount;
  /** RefundID: identifies the refund */
  RefundID: Scalars['UUID'];
  /** RequestTime: timestamp when the request for the refund was made */
  RequestTime: Scalars['AWSDateTime'];
  /** Status: status of the refund */
  Status: FiatPaymentStatus;
};

export type FiatPaymentResponse = {
  /** Links: links relevant to the payment (redirects / receipts) */
  Links?: Maybe<Array<FiatPaymentResponseLink>>;
  /** Payment: the payment that was created or an already processing payment based on Nonce. */
  Payment: FiatPayment;
};

export type FiatPaymentResponseLink = {
  LinkType: Scalars['String'];
  Location: Scalars['String'];
};

export enum FiatPaymentStatus {
  /** Failed: funds were not received / sent */
  Failed = 'Failed',
  /** Pending: user needs to complete further actions for the funds to be captured (e.g. 3DS check) / funds are being processed */
  Pending = 'Pending',
  /** Successful: funds have been captured / sent successfully */
  Successful = 'Successful',
}

/** FiatPaymentTokenizationSource: source of the payment tokenization */
export enum FiatPaymentTokenizationSource {
  ApplePay = 'ApplePay',
  /** Checkout: Payment is tokenized by Checkout (via API or Frames) */
  Checkout = 'Checkout',
  GooglePay = 'GooglePay',
}

export enum FiatPaymentType {
  EPS = 'EPS',
  /** FiatPaymentMethodID: a payment method previously stored in our database */
  FiatPaymentMethodID = 'FiatPaymentMethodID',
  Giropay = 'Giropay',
  Sofort = 'Sofort',
}

/** FiatPaymentWalletCard: a card that represents a user's phone wallet card such as google pay / apple pay */
export type FiatPaymentWalletCard = FiatPaymentMethodDetails & {
  /** BillingAddress: the billing address for the payment method */
  BillingAddress?: Maybe<StreetAddress>;
  /** Bin: the bank identification number of the card */
  Bin: Scalars['String'];
  /** ExpiryMonth: the expiry month of the card. Contains 1-2 characters */
  ExpiryMonth: Scalars['Int'];
  /** ExpiryYear: the expiry year of the card. Contains 4 characters */
  ExpiryYear: Scalars['Int'];
  /** Last4: the last 4 digits of the card */
  Last4: Scalars['String'];
  /** Payout: payout estimation and raw data from the provider. */
  Payout: Payout;
  /** Reusable: indicates that the payment method can be reused */
  Reusable: Scalars['Boolean'];
  /** WalletType: the type of wallet */
  WalletType: FiatPaymentWalletCardType;
};

export type FiatPaymentWalletCardInput = {
  /** BillingAddress: the billing address for the payment method */
  BillingAddress?: InputMaybe<StreetAddressInput>;
  /** Bin: the bank identification number of the card */
  Bin: Scalars['String'];
  /** ExpiryMonth: the expiry month of the card. Contains 1-2 characters */
  ExpiryMonth: Scalars['Int'];
  /** ExpiryYear: the expiry year of the card. Contains 4 characters */
  ExpiryYear: Scalars['Int'];
  /** Last4: the last 4 digits of the card */
  Last4: Scalars['String'];
  /** WalletType: the type of wallet */
  WalletType: FiatPaymentWalletCardType;
};

export enum FiatPaymentWalletCardType {
  ApplePay = 'ApplePay',
  GooglePay = 'GooglePay',
}

export type FiatPayoutInput = {
  /** ChannelID: channel ID to use for the payout. */
  ChannelID?: InputMaybe<Scalars['UUID']>;
  /**
   * MaximumDeduction: maximum deduction that can be taken from user's crypto account.
   * This amount should be derived from the liquidity provider's offer price and include fees and slippage.
   */
  MaximumDeduction: Scalars['Decimal'];
  /** Nonce: unique value sent from client. */
  Nonce?: InputMaybe<Scalars['Nonce']>;
  /** PaymentDetails: payment details for the payment. */
  PaymentDetails: FiatPaymentDetailsInput;
  /** RequestedAmount: requested amount of fiat to sell. This will be the amount user gets sent to their fiat payment method. */
  RequestedAmount: FiatAmountInput;
  /**
   * Signature: signature with user's signing key, of the form v1/DateTime/base64(sign(Nonce/DateTime/CurrencyCode/AccountType/Amount/Destination))
   * Nonce, which uniqueness is enforced, is included to verify that signature is not reused.
   * Signature is valid for 10 minutes.
   */
  Signature?: InputMaybe<Scalars['String']>;
  /** SourceCurrency: what currency to sell (Crypto). */
  SourceCurrency: CurrencyCode;
};

/** FiatRequestedAmountInput: fiat amount request */
export type FiatRequestedAmountInput = {
  /** Amount: amount of fiat currency in minor currency unit (cents / pence / etc.) */
  Amount: Scalars['String'];
  /** FiatCurrency: used fiat currency */
  FiatCurrency: FiatCurrencyCode;
};

/**
 * FinService: A 3rd party that provides some financial service to NOAH. This
 * could be facilitation of payments, liquidity provisioning or any other kind of
 * financial service.
 */
export enum FinService {
  /** Cko: checkout.com - Global payment processor. */
  Cko = 'Cko',
  /** Fireblocks: fireblocks.com - Digital assets management. */
  Fireblocks = 'Fireblocks',
  /** Flutterwave: flutterwave.com - African payment processor. */
  Flutterwave = 'Flutterwave',
  /** Onafriq: onafriq.com - African payment processor. */
  Onafriq = 'Onafriq',
  /** Remitee: remitee.com - South American payment processor. */
  Remitee = 'Remitee',
  /** Revolut: revolut.com - Our treasury bank. */
  Revolut = 'Revolut',
  /** Wintermute: wintermute.com - Algo traders that provide us crypto liquidity. */
  Wintermute = 'Wintermute',
  /** Woorton: woorton.com - Market makers that provide us crypto liquidity. */
  Woorton = 'Woorton',
}

/** FireblocksTransactionStatus: transaction status from Fireblocks */
export enum FireblocksTransactionStatus {
  /** BLOCKED: the transaction was blocked due to a policy rule */
  BLOCKED = 'BLOCKED',
  /** BROADCASTING: the transaction is pending broadcast to the blockchain network */
  BROADCASTING = 'BROADCASTING',
  /**
   * CANCELLED: the transaction was cancelled or rejected by the user on the Fireblocks platform or
   * by the 3rd party service from which the funds are withdrawn
   */
  CANCELLED = 'CANCELLED',
  /** COMPLETED: transaction is completed */
  COMPLETED = 'COMPLETED',
  /** CONFIRMING: pending confirmation on the blockchain */
  CONFIRMING = 'CONFIRMING',
  /** FAILED: the transaction has failed */
  FAILED = 'FAILED',
  /** PARTIALLY_COMPLETED: (Only for Aggregated transactions) One or more of of the transaction records have completed successfully */
  PARTIALLY_COMPLETED = 'PARTIALLY_COMPLETED',
  /** PENDING_3RD_PARTY: the transaction is pending approval by the 3rd party service (e.g exchange) */
  PENDING_3RD_PARTY = 'PENDING_3RD_PARTY',
  /** PENDING_3RD_PARTY_MANUAL_APPROVAL: the transaction is pending manual approval as required by the 3rd party, usually an email approval */
  PENDING_3RD_PARTY_MANUAL_APPROVAL = 'PENDING_3RD_PARTY_MANUAL_APPROVAL',
  /** PENDING_AML_SCREENING: in case the AML screening feature is enabled, transaction is pending AML screening result */
  PENDING_AML_SCREENING = 'PENDING_AML_SCREENING',
  /** PENDING_AUTHORIZATION: the transaction is pending authorization by other users (as defined in the Transaction Authorization Policy) */
  PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION',
  /** PENDING_SIGNATURE: the transaction is pending the initiator to sign the transaction */
  PENDING_SIGNATURE = 'PENDING_SIGNATURE',
  /** QUEUED: transaction is queued. Pending for another transaction to be processed */
  QUEUED = 'QUEUED',
  /** REJECTED: the transaction was rejected by the Fireblocks system or by the 3rd party service */
  REJECTED = 'REJECTED',
  /** SUBMITTED: the transaction was submitted to the Fireblocks system and is being processed */
  SUBMITTED = 'SUBMITTED',
}

/** FireblocksTransactionSubStatus: transaction sub-status from Fireblocks */
export enum FireblocksTransactionSubStatus {
  /** CONFIRMED: transaction is confirmed on blockchain */
  CONFIRMED = 'CONFIRMED',
}

/** FireblocksWebhookEventType: types of webhook events from Fireblocks */
export enum FireblocksWebhookEventType {
  /** TRANSACTION_CREATED: transaction created in Fireblocks */
  TRANSACTION_CREATED = 'TRANSACTION_CREATED',
  /** TRANSACTION_STATUS_UPDATED: transaction status updated in Fireblocks */
  TRANSACTION_STATUS_UPDATED = 'TRANSACTION_STATUS_UPDATED',
}

/**
 * FormBankAccountType: Used in the input forms to denote the type of bank accounts
 * in the local terminology of the destination.
 */
export enum FormBankAccountType {
  /**
   * Checking: is an account that is used for everyday transactions.
   * It is also similar to a current account.
   */
  Checking = 'Checking',
  /**
   * Current: is an account that is used for everyday transactions.
   * It is also similar to a checking account.
   */
  Current = 'Current',
  /** Savings: account used to earn interest on easily accessible cash */
  Savings = 'Savings',
}

export type FormSession = {
  ChannelID: Scalars['UUID'];
  ComplianceData?: Maybe<PaymentComplianceData>;
  CustomerID: Scalars['CustomerID'];
  DynamoTTL: Scalars['Int'];
  ID: Scalars['UUID'];
  PaymentMethodID: Scalars['String'];
  UserID: Scalars['UserID'];
};

/** FullName: The components of a person's name. */
export type FullName = {
  /** FirstName: user's first name */
  FirstName: Scalars['String'];
  /** LastName: user's last name (family name) */
  LastName: Scalars['String'];
  /** MiddleName: user's middle name */
  MiddleName?: Maybe<Scalars['String']>;
};

export type FullNameInput = {
  /** FirstName: user's first name */
  FirstName: Scalars['String'];
  /** LastName: user's last name (family name) */
  LastName: Scalars['String'];
  /** MiddleName: user's middle name */
  MiddleName?: InputMaybe<Scalars['String']>;
};

export type FundingBalance = {
  /** AssetID: the account currency code. This can be crypto or fiat. */
  AssetID: Scalars['AssetID'];
  /** ExpectedBalance: how much we expect to have in this account. */
  ExpectedBalance: Scalars['Decimal'];
  /** FinService: who is hosting/providing the account. */
  FinService: FinService;
  /** Outflow: total amount of pending transactions that will reduce the balance of this account once settled. */
  Outflow: Scalars['Decimal'];
  /** Reference: how to reference this account in the 3rd party system. */
  Reference: Scalars['String'];
};

export type FundingOrder = {
  /** Amount: how much funding was sent. */
  Amount: Scalars['Decimal'];
  /** AssetID: the account currency code. This can be crypto or fiat. */
  AssetID: Scalars['AssetID'];
  /** CreatedAt: when the order was created. */
  CreatedAt: Scalars['AWSDateTime'];
  /** DynamoID: [FinService]/[Reference] */
  DynamoID: Scalars['DynamoID'];
  /** ID: Unique identifier for the order. */
  ID: Scalars['UUID'];
  /** Status: the current status of the order. */
  Status: FundingOrderStatus;
  /** UpdatedAt: when the order was last updated. */
  UpdatedAt: Scalars['AWSDateTime'];
};

export enum FundingOrderStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Settled = 'Settled',
}

export enum IdentificationFileSide {
  Back = 'Back',
  Front = 'Front',
}

export enum IdentifierPaymentSystem {
  /** Pix: Brazilian Pix */
  Pix = 'Pix',
}

export enum IdentityType {
  AddressProof = 'AddressProof',
  DrivingLicense = 'DrivingLicense',
  NationalIDCard = 'NationalIDCard',
  Passport = 'Passport',
  ResidencePermit = 'ResidencePermit',
  /** TaxID: Tax Identification Number. It might not have a file associated with it. */
  TaxID = 'TaxID',
}

export type IntercomIdentifyHashResponse = {
  UserHash?: Maybe<Scalars['String']>;
};

export type InvoiceExpiryStateMachineInput = {
  ExpiryTime: Scalars['String'];
  NoahID: Scalars['NoahID'];
};

/** JwtToken: JWT token for accessing services */
export type JwtToken = {
  /** Token: JWT token */
  Token: Scalars['String'];
};

/** Kyb: Fields related to user's KYB verification */
export type Kyb = {
  /** BusinessName: Name of the business */
  BusinessName: Scalars['String'];
  /** Url: URL to the business website */
  Url: Scalars['String'];
};

export enum KycActionRequired {
  HighRiskDataSubmit = 'HighRiskDataSubmit',
  MandatoryDataSubmit = 'MandatoryDataSubmit',
  Retry = 'Retry',
  Review = 'Review',
}

/** KycAddress: Address data extracted from user's KYC document(s). */
export type KycAddress = {
  /** City: name of an address's city or town. */
  City?: Maybe<Scalars['String']>;
  /** CountryCode: user's country code */
  CountryCode: Scalars['CountryCode'];
  /** PostCode: the address's postcode */
  PostCode?: Maybe<Scalars['String']>;
  /** State: the address's state / province / county */
  State?: Maybe<Scalars['String']>;
  /** Street: the primary name of an address's street. */
  Street?: Maybe<Scalars['String']>;
  /** Street2: the secondary name of an address's street. */
  Street2?: Maybe<Scalars['String']>;
};

export enum KycApprovalStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Pending = 'Pending',
}

export enum KycDocumentVerificationStatus {
  /** Complete: verification complete */
  Complete = 'Complete',
  /** Failed: failed verification */
  Failed = 'Failed',
  /** Pending: user has submitted the document for verification */
  Pending = 'Pending',
}

export enum KycLevel {
  Basic = 'Basic',
  Edd = 'Edd',
  Full = 'Full',
}

export enum KycRejectType {
  /** Final: rejection is final */
  Final = 'Final',
  /** Retry: user can retry the KYC process */
  Retry = 'Retry',
}

/**
 * KycRejectionData: stores data about the applicants that were rejected after following the SumSub KYC process
 * https://developers.sumsub.com/api-reference/#getting-verification-results
 */
export type KycRejectionData = {
  /** ClientComment: A human-readable comment that should not be shown to an end user, and is meant to be read by a client */
  ClientComment?: Maybe<Scalars['String']>;
  /** ModerationComment: A human-readable comment that can be shown to your end user */
  ModerationComment?: Maybe<Scalars['String']>;
  /** RejectLabels: list of rejection labels */
  RejectLabels: Array<Scalars['String']>;
  /** RejectType: type of rejection */
  RejectType: KycRejectType;
};

/** KycVerification: Fields related to user's KYC verification, fields are null if user has not verified */
export type KycVerification = {
  /** ActionRequired: Action required to progress the KYC process */
  ActionRequired?: Maybe<KycActionRequired>;
  /** ApprovalStatus: Internal status of the user's KYC acceptance */
  ApprovalStatus?: Maybe<KycApprovalStatus>;
  /**
   * DocumentVerificationStatus: Status of the user's KYC progress in the KYC provider
   * @deprecated DocumentVerificationStatus field is deprecated and should not be used.
   */
  DocumentVerificationStatus?: Maybe<KycDocumentVerificationStatus>;
  /** ID: Verification ID from the KYC provider, null if the user has not verified */
  ID?: Maybe<Scalars['String']>;
  /** KycLevel: Which KYC level is the user currently attempting */
  KycLevel?: Maybe<KycLevel>;
  /** LastUpdated: Time the verification was last updated */
  LastUpdated?: Maybe<Scalars['AWSDateTime']>;
  /** RejectType: if the KYC was not successful, data about the rejection will be populated. */
  RejectionData?: Maybe<KycRejectionData>;
};

export type Ledger = {
  name: Scalars['String'];
};

/**
 * LedgerTransaction:
 * Describes deposit or withdrawal transactions that are committed to our ledger.
 * With the exception of the Status and Modified* fields, all fields should be immutable once set.
 * We have indexes on: NoahID and PublicID.
 */
export type LedgerTransaction = {
  /** Amount: the incoming or outgoing absolute amount of the transaction (i.e. no -ve numbers) */
  Amount: Scalars['Decimal'];
  /** AmountUSD: the usd amount (i.e. the usd amount from the fireblocks transaction) */
  AmountUSD?: Maybe<Scalars['String']>;
  /** Created: date when the transaction was created */
  Created: Scalars['AWSDateTime'];
  /** Currency: the currency type of the transaction */
  Currency: CurrencyCode;
  /** Destination: the end location of this transaction */
  Destination?: Maybe<DestinationAddress>;
  /** DestinationAccountID: identifies the destination account ID */
  DestinationAccountID?: Maybe<Scalars['AccountID']>;
  /** DestinationOut: for UTXO based assets this is the vOut, for Ethereum based, this is the index of the event of the contract call */
  DestinationOut?: Maybe<Scalars['Int']>;
  /** DestinationRecords: records of operations perfomed on a destination transaction */
  DestinationRecords?: Maybe<Array<TransactionRecord>>;
  /** Destination Type: type of destination */
  DestinationType?: Maybe<TransferDestinationType>;
  /** FireblocksIDs: fireblocks identifiers for the public transaction */
  FireblocksIDs?: Maybe<Array<Scalars['FireblocksID']>>;
  /**
   * MarketAmount: amount of fiat that the crypto was worth at the time transaction
   * or order was committed to ledger
   */
  MarketAmount?: Maybe<FiatAmount>;
  /**
   * MoonpayID: the unique identifier of this transaction
   *
   * @deprecated Moonpay is deprecated and should not be used.
   */
  MoonpayID?: Maybe<Scalars['MoonpayID']>;
  /** Network: Network of the transaction */
  Network: Network;
  /** NoahID: the unique identifier of this transaction */
  NoahID: Scalars['NoahID'];
  /** Operation: Operation of the transaction, such as Transfer */
  Operation: TransactionOperation;
  /** PublicID: the unique identifier of this transaction */
  PublicID: Scalars['PublicID'];
  /**
   * RequestedAmount: amount of fiat that user requested to transact.
   * This amount is informative and can be manipulated by user.
   * Market and order amounts are expected to be near this number but
   * this might be what user expects to see and user might be easiser to read.
   */
  RequestedAmount?: Maybe<FiatAmount>;
  /** Reverses: transaction that this transaction reverses (may reverse partially) */
  Reverses?: Maybe<Scalars['NoahID']>;
  /** Source: the origin location of this transaction */
  Source?: Maybe<SourceAddress>;
  /** SourceAccountID: identifies the source account ID */
  SourceAccountID?: Maybe<Scalars['AccountID']>;
  /** SourceID: identifier of the source */
  SourceID?: Maybe<Scalars['String']>;
  /** SourceRecords: records of operations perfomed on a source transaction */
  SourceRecords?: Maybe<Array<TransactionRecord>>;
  /** SourceType: type of the source */
  SourceType?: Maybe<TransferSourceType>;
  /** Status: the current status of the transaction on the Noah Ledger */
  Status: TransactionStatus;
  /** Steps: is a record of the outcome of our validation & verification steps */
  Steps: TransactionSteps;
  /** WithdrawOrderID: withdraw order for which this transaction was created for */
  WithdrawOrderID?: Maybe<Scalars['WithdrawOrderID']>;
};

/** LedgerUserLimits: user's limits that are stored in the ledger */
export type LedgerUserLimits = {
  /** Limits: user's limits */
  Limits: Array<UserLimit>;
  /** UserID: identifies the owner of the limits */
  UserID: Scalars['UserID'];
};

/** LightningAddressInvoiceProxyInput: request a payment request for a lightning address */
export type LightningAddressInvoiceProxyInput = {
  Amount: Scalars['Decimal'];
  LightningAddress?: InputMaybe<Scalars['String']>;
  LnurlLink?: InputMaybe<Scalars['String']>;
};

export type LightningAddressInvoiceProxyResponse = LightningAddressInvoiceProxySuccess | LnurlError;

/** LightningAddressInvoiceProxySuccess: payment request for a lightning address */
export type LightningAddressInvoiceProxySuccess = {
  /** PaymentRequest: lightning payment request */
  PaymentRequest: Scalars['PaymentRequest'];
  /** PublicID: hex-encoded invoice hash which uniquely identifies the invoice */
  PublicID: Scalars['PublicID'];
};

/** LightningAddressProxyInput: request lightning address details */
export type LightningAddressProxyInput = {
  LightningAddress?: InputMaybe<Scalars['String']>;
  LnurlLink?: InputMaybe<Scalars['String']>;
};

export type LightningAddressProxyResponse = LightningAddressProxySuccess | LnurlError;

/** LightningAddressProxySuccess: lightning address details response */
export type LightningAddressProxySuccess = {
  /** Description: short description to display when paying */
  Description: Scalars['String'];
  /** LongDescription: long description to display when paying */
  LongDescription?: Maybe<Scalars['String']>;
  /** MaxSendable: maximum value allowed for LightningAddressInvoiceProxyInput.Amount */
  MaxSendable: Scalars['Decimal'];
  /** MinSendable: minimum value allowed for LightningAddressInvoiceProxyInput.Amount */
  MinSendable: Scalars['Decimal'];
  /** Picture: base64 encoded 512x512px PNG or JPG thumbnail */
  Picture?: Maybe<Scalars['String']>;
  /** Tag: string to identify the request type */
  Tag: Scalars['String'];
};

/** LightningInvoiceCreateInput: request to create a lightning invoice */
export type LightningInvoiceCreateInput = {
  /** AccountType: which AccountType this withdrawal is from */
  AccountType: AccountType;
  /** Amount: decimal amount to withdraw in account's base currency unit (like BTC / ETH), use '0' for sender to decide the amount */
  Amount: Scalars['Decimal'];
  /** CurrencyCode: the currency code of this withdrawal request */
  CurrencyCode: CurrencyCode;
  /** Description: invoice description included in payment request */
  Description?: InputMaybe<Scalars['String']>;
  /**
   * RequestedAmount: fiat amount that user entered to invoice.
   * Defining this indicates that user specifically entered this amount, not only that this amount displayed as estimate.
   */
  RequestedAmount?: InputMaybe<FiatAmountInput>;
};

/** LightningInvoiceCreateResponse: response for lightning invoice creation */
export type LightningInvoiceCreateResponse = {
  /**
   * PaymentRequest: the lightning payment request string.
   * User will share this string with sender or will present a QR image generated from this string.
   */
  PaymentRequest: Scalars['PaymentRequest'];
  /** PublicID: hex-encoded invoice hash which uniquely identifies the invoice */
  PublicID: Scalars['PublicID'];
};

/** LightningPaymentRequest: lightning payment request */
export type LightningPaymentRequest = {
  /** Description: payment request description */
  Description?: Maybe<Scalars['String']>;
  /** Expiry: time from which the invoice cannot be paid anymore */
  Expiry: Scalars['AWSDateTime'];
  /** PaymentRequest: lightning payment request */
  PaymentRequest: Scalars['PaymentRequest'];
};

/** LightningPaymentRequestInput: get payment request */
export type LightningPaymentRequestInput = {
  /** PublicID: hex-encoded invoice hash which uniquely identifies the invoice */
  PublicID: Scalars['PublicID'];
};

/** LightningPaymentSendInput: request to pay a lightning invoice */
export type LightningPaymentSendInput = {
  /** AccountType: which AccountType this withdrawal is from */
  AccountType: AccountType;
  /** Amount: decimal amount to withdraw in account's base currency unit (like BTC / ETH). Only needed if invoice amount was 0 */
  Amount?: InputMaybe<Scalars['Decimal']>;
  /** CurrencyCode: the currency code of this withdrawal request */
  CurrencyCode: CurrencyCode;
  /** DestinationType: destination type */
  DestinationType?: InputMaybe<TransferDestinationTypeInput>;
  /** Nonce: unique value sent from client. */
  Nonce?: InputMaybe<Scalars['Nonce']>;
  /** PaymentRequest: the lightning payment request string */
  PaymentRequest: Scalars['PaymentRequest'];
  /**
   * RequestedAmount: fiat amount that user entered to send.
   * Defining this indicates that user specifically entered this amount, not only that this amount displayed as estimate.
   */
  RequestedAmount?: InputMaybe<FiatAmountInput>;
  /**
   * Signature: signature with user's signing key, of the form v1/DateTime/base64(sign(Nonce/DateTime/CurrencyCode/AccountType/Amount/Destination))
   * Nonce, which uniqueness is enforced, is included to verify that signature is not reused.
   * Signature is valid for 10 minutes.
   */
  Signature?: InputMaybe<Scalars['String']>;
};

export type LiquidityOrder = {
  /** Amount: oustanding amount to be filled */
  Amount: Scalars['Decimal'];
  /** Currency of the order */
  Currency: CurrencyCode;
  /** FiatCurrency: Fiat currency used for the order */
  FiatCurrency: FiatCurrencyCode;
  /** ID: Unique identifier of the order */
  ID: Scalars['String'];
  /** PlaceTime: Time at which the order was placed, null if still filling */
  PlaceTime?: Maybe<Scalars['AWSDateTime']>;
  /** PlacedPrice: Price at which the order was placed, null if still filling */
  PlacedPrice?: Maybe<Scalars['Decimal']>;
  /** Settlement: Information about how this liquidity order was settled */
  Settlement?: Maybe<LiquiditySettlement>;
  /** Status: Status of the order */
  Status: LiquidityOrderStatus;
};

export enum LiquidityOrderStatus {
  Filling = 'Filling',
  Placing = 'Placing',
  Settled = 'Settled',
}

export type LiquidityPrice = {
  /** BuyPrice: the best price to buy */
  BuyPrice: Scalars['Decimal'];
  /** FetchedAt: the time the price was taken */
  FetchedAt: Scalars['AWSDateTime'];
  /** SellPrice: the best price to sell */
  SellPrice: Scalars['Decimal'];
};

export enum LiquidityProvider {
  Woorton = 'Woorton',
}

export type LiquiditySettlement = {
  /**
   * GroupID: This refers to how the liquidity order was executed. Every order
   * should be settled as part of a group. Groups may contain only 1 liquidity orders.
   * This can be used as dedup identifier with the provider.
   */
  GroupID: Scalars['String'];
  /** Price: The price at which the order was settled at. */
  Price?: Maybe<Scalars['Decimal']>;
  /** Provider: Who provided liquidity for this order. */
  Provider?: Maybe<LiquidityProvider>;
  /** Quantity: The total amount of the asset traded as part of this settlement. */
  Quantity?: Maybe<Scalars['Decimal']>;
  /** Reference: The provider identifier for the order that settled this. */
  Reference?: Maybe<Scalars['String']>;
  /** SettledAt: When the order was settled at with the provider. */
  SettledAt?: Maybe<Scalars['AWSDateTime']>;
};

/** LnurlError: error from LNURL endpoint */
export type LnurlError = {
  /** Domain: LN Service domain name */
  Domain: Scalars['String'];
  /** Reason: freetext reason from LN Service */
  Reason: Scalars['String'];
  /** Status: LNURL status from LN Service such as ERROR */
  Status: Scalars['String'];
};

export enum LogLevel {
  debug = 'debug',
  error = 'error',
  info = 'info',
  none = 'none',
  warn = 'warn',
}

export enum LogObject {
  AlertEvent = 'AlertEvent',
  LedgerResult = 'LedgerResult',
}

export enum LoggerMode {
  Dev = 'Dev',
  Prod = 'Prod',
}

/** MainLedgerTables: an enum describing the tables that are created in the main Ledger */
export enum MainLedgerTables {
  accounts = 'accounts',
  apikeys = 'apikeys',
  balances = 'balances',
  depositaddresses = 'depositaddresses',
  fireblocks = 'fireblocks',
  moonpay = 'moonpay',
  rewards = 'rewards',
  signingkeys = 'signingkeys',
  transactions = 'transactions',
  userlimits = 'userlimits',
  withdraworders = 'withdraworders',
}

export type ManualFinopsInput = {
  Amount: Scalars['Decimal'];
  CurrencyCode: CurrencyCode;
  Network: Network;
  Nonce: Scalars['Nonce'];
};

export type ManualRampCurrencySettings = {
  FeeMinimumFiatAmount: Scalars['Decimal'];
  FeePercentage: Scalars['Decimal'];
  FiatCurrency: FiatCurrencyCode;
  MinimumFiatAmount: Scalars['Decimal'];
};

export enum MarketDataService {
  CoinGecko = 'CoinGecko',
  Remitee = 'Remitee',
}

export type MarketPrice = {
  /** FetchedAt: the time the price was taken */
  FetchedAt: Scalars['AWSDateTime'];
  /** Price: price of the requested currency in fiat currency */
  Price: Scalars['Decimal'];
};

export type MarketPriceInput = {
  /** CurrencyCode: the currency to get market price for */
  CurrencyCode: CurrencyCode;
  /** FiatCurrency: used fiat currency */
  FiatCurrency: FiatCurrencyCode;
};

export type MarketingCode = {
  EndedResponse: Scalars['String'];
  Ends: Scalars['AWSDateTime'];
  MarketingCodeID: Scalars['MarketingCodeID'];
  OpenResponse: Scalars['String'];
  Source: Scalars['String'];
  Starts?: Maybe<Scalars['AWSDateTime']>;
};

export type MarketingCodeCreateInput = {
  /** EndedResponse: response text when code is applied after end date */
  EndedResponse?: InputMaybe<Scalars['String']>;
  /** Ends: time the code is no longer valid */
  Ends: Scalars['AWSDateTime'];
  /** Open Response: response text on successful application of code */
  OpenResponse?: InputMaybe<Scalars['String']>;
  /** Name: Name of the source of the marketing code */
  Source: Scalars['String'];
  /** Starts: time the code begins to be valid */
  Starts?: InputMaybe<Scalars['AWSDateTime']>;
};

export type MarketingCodeInput = {
  /** Code: marketing code */
  Code: Scalars['String'];
};

export type MarketingCodeResponse = {
  /** Description: description of the outcome of using the code */
  Description: Scalars['String'];
};

export enum ModelAttributeTypes {
  _null = '_null',
  binary = 'binary',
  binarySet = 'binarySet',
  bool = 'bool',
  list = 'list',
  map = 'map',
  number = 'number',
  numberSet = 'numberSet',
  string = 'string',
  stringSet = 'stringSet',
}

export type ModelDecimalInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  eq?: InputMaybe<Scalars['Decimal']>;
  ge?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  le?: InputMaybe<Scalars['Decimal']>;
  lt?: InputMaybe<Scalars['Decimal']>;
  ne?: InputMaybe<Scalars['Decimal']>;
};

export type ModelDestinationInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
};

export type ModelStringInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']>;
  beginsWith?: InputMaybe<Scalars['String']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  ge?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  le?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  notContains?: InputMaybe<Scalars['String']>;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type Mutation = {
  accountCreate: AccountCreateResponse;
  claim: AwsEventBridgeResponse;
  createApiKey: ApiKey;
  deleteApiKey: ApiKey;
  fiatPayment: FiatPaymentResponse;
  fiatPaymentAppleSession: FiatPaymentAppleSessionResponse;
  fiatPaymentMethodBankSave: FiatPaymentMethod;
  fiatPaymentMethodDelete: FiatPaymentMethod;
  fiatPaymentMethodTokenizedCardSave: FiatPaymentMethod;
  fiatPaymentMethodUpdate: FiatPaymentMethod;
  fiatPaymentMethodWalletCardSave: FiatPaymentMethod;
  fiatPayout: AwsEventBridgeResponse;
  lightningInvoiceCreate: LightningInvoiceCreateResponse;
  lightningPaymentSend: AwsEventBridgeResponse;
  marketingCode: MarketingCodeResponse;
  pubAccountUpdate: SubAccountResponse;
  sardineDevices: SardineDevicesResponse;
  sumSubAccessToken: SumSubAccessTokenResponse;
  updateUserLimits: UserLimitUpdateResponse;
  userAppSettingsUpdate: UserProfile;
  userFiatPaymentCurrencyUpdate: UserProfile;
  userMetadataUpdate: UserProfile;
  userProfileCreate: UserProfile;
  userSettingsConsentCreate: UserSettingsConsent;
  webhookSubscriptionCreate: WebhookSubscription;
  webhookSubscriptionDelete: WebhookSubscription;
  whitelistAddressCreate: WhitelistAddress;
  whitelistAddressDelete: WhitelistAddress;
  withdrawOrderCreate: AwsEventBridgeResponse;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationAccountCreateArgs = {
  Input?: InputMaybe<AccountCreateInput>;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationClaimArgs = {
  Input: ClaimInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationCreateApiKeyArgs = {
  Input: CreateApiKeyInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationDeleteApiKeyArgs = {
  Input: DeleteApiKeyInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPaymentArgs = {
  Input: FiatPaymentInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPaymentAppleSessionArgs = {
  Input: FiatPaymentAppleSessionInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPaymentMethodBankSaveArgs = {
  Input: FiatPaymentBankSaveInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPaymentMethodDeleteArgs = {
  Input: FiatPaymentMethodDeleteInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPaymentMethodTokenizedCardSaveArgs = {
  Input: FiatPaymentMethodTokenizedCardSaveInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPaymentMethodUpdateArgs = {
  Input: FiatPaymentMethodUpdateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPaymentMethodWalletCardSaveArgs = {
  Input: FiatPaymentMethodWalletCardSaveInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationFiatPayoutArgs = {
  Input: FiatPayoutInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationLightningInvoiceCreateArgs = {
  Input: LightningInvoiceCreateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationLightningPaymentSendArgs = {
  Input: LightningPaymentSendInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationMarketingCodeArgs = {
  Input: MarketingCodeInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationPubAccountUpdateArgs = {
  Input: Scalars['AWSJSON'];
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationSumSubAccessTokenArgs = {
  Input: SumSubAccessTokenInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationUpdateUserLimitsArgs = {
  Input: UserLimitUpdateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationUserAppSettingsUpdateArgs = {
  Input: UserAppSettingsUpdateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationUserFiatPaymentCurrencyUpdateArgs = {
  Input: UserFiatPaymentCurrencyUpdate;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationUserMetadataUpdateArgs = {
  Input: UserMetadataUpdateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationUserProfileCreateArgs = {
  Input: UserProfileCreateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationUserSettingsConsentCreateArgs = {
  Input: UserSettingsConsentInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationWebhookSubscriptionCreateArgs = {
  Input: WebhookSubscriptionCreateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationWebhookSubscriptionDeleteArgs = {
  Input: WebhookSubscriptionDeleteInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationWhitelistAddressCreateArgs = {
  Input: WhitelistAddressCreateInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationWhitelistAddressDeleteArgs = {
  Input: WhitelistAddressDeleteInput;
};

/** Always use 'Input' as the root parameter, with input types on top */
export type MutationWithdrawOrderCreateArgs = {
  Input?: InputMaybe<WithdrawOrderCreateRequestInput>;
};

/** Network: Payments network */
export enum Network {
  /** Bitcoin: Bitcoin mainnet */
  Bitcoin = 'Bitcoin',
  /** BitcoinTest: Bitcoin testnet (version 3) */
  BitcoinTest = 'BitcoinTest',
  /** Ethereum: Ethereum mainnet */
  Ethereum = 'Ethereum',
  /** Ethereum: Ethereum testnet (Sepolia) */
  EthereumTestSepolia = 'EthereumTestSepolia',
  /** Lightning: Lightning mainnet */
  Lightning = 'Lightning',
  /** LightningTest: Lightning testnet */
  LightningTest = 'LightningTest',
  /** OffNetwork: Transaction outside crypto network */
  OffNetwork = 'OffNetwork',
  /** PolygonPos: Polygon Pos network */
  PolygonPos = 'PolygonPos',
  /** PolygonTestAmoy: Polygon testnet (Amoy) */
  PolygonTestAmoy = 'PolygonTestAmoy',
  /**
   * PolygonTestMumbai: Polygon testnet (Mumbai)
   *
   * @deprecated Mumbai testnet is not functional.
   */
  PolygonTestMumbai = 'PolygonTestMumbai',
  /** Tron: Tron network */
  Tron = 'Tron',
  /** TronTestShasta: Tron testnet (Shasta) */
  TronTestShasta = 'TronTestShasta',
}

/** NoahError: error that Noah has encountered */
export type NoahError = {
  /** Action: What was the code trying to do when the error occurred */
  Action: Scalars['String'];
  /** Cause: the raw error object */
  Cause: Scalars['ErrorObject'];
  /** Detail: (from RFC7807) A human-readable explanation specific to this occurrence of the problem */
  Detail: Scalars['String'];
  /** Extensions: (from RFC7807) extra error data */
  Extensions?: Maybe<Scalars['AWSJSON']>;
  /** Handler: Handler in which the error occurred */
  Handler: Scalars['String'];
  /** Instance: (from RFC7807) A unique reference that identifies the specific occurrence of the problem */
  Instance: Scalars['String'];
  /** Status: (from RFC7807) The advised HTTP status code applicable to this problem */
  Status: Scalars['Int'];
  /** Title: (from RFC7807) The string description that comes from the Type enum */
  Title: Scalars['String'];
  /** Type: (from RFC7807) Enum about what caused this error */
  Type: NoahErrorType;
};

/** NoahErrorType: (from RFC7807) Enum about what caused this error */
export enum NoahErrorType {
  /** AwaitingFunding: a system needs funding to perform payment */
  AwaitingFunding = 'AwaitingFunding',
  /** AwaitingLiquidity: liquidity order has not been placed */
  AwaitingLiquidity = 'AwaitingLiquidity',
  /** BalanceTransition: balance couldn't be updated because the new balance would be illegal */
  BalanceTransition = 'BalanceTransition',
  /** DropMessage: a message that is droppe invalid */
  DropMessage = 'DropMessage',
  /** Duplicate: received duplicate event or message */
  Duplicate = 'Duplicate',
  /** DynamoDbExecute: error reading or writing data to dynamo db */
  DynamoDbExecute = 'DynamoDbExecute',
  /** ExternalConnection: connection to external system failed or timed out */
  ExternalConnection = 'ExternalConnection',
  /** ExternalSystem: unexpected error in an external system */
  ExternalSystem = 'ExternalSystem',
  /** Forbidden: access forbidden, client is authenticated but not allowed */
  Forbidden = 'Forbidden',
  /** InsufficientBalance: insufficient balance in user's account */
  InsufficientBalance = 'InsufficientBalance',
  /** InsufficientLiquidity: insufficient liquidity to perform operation */
  InsufficientLiquidity = 'InsufficientLiquidity',
  /** InternalConnection: connection to internal system failed or timed out */
  InternalConnection = 'InternalConnection',
  /** InternalSystem: unexpected error interacting with an internal system */
  InternalSystem = 'InternalSystem',
  /** InvalidEmail: invalid email */
  InvalidEmail = 'InvalidEmail',
  /** InvalidMessage: message is invalid */
  InvalidMessage = 'InvalidMessage',
  /** InvalidRewardTarget: when the target of a reward is not supposed receive rewards */
  InvalidRewardTarget = 'InvalidRewardTarget',
  /** InvalidUsername: invalid username */
  InvalidUsername = 'InvalidUsername',
  /** LedgerExecute: error reading or writing data to ledger */
  LedgerExecute = 'LedgerExecute',
  /** Misconfiguration: misconfiguration in infrastructure */
  Misconfiguration = 'Misconfiguration',
  /** PaymentRejection: payment entity rejected request */
  PaymentRejection = 'PaymentRejection',
  /** PolicyViolation: violated one or more policies */
  PolicyViolation = 'PolicyViolation',
  /** ReconcileIntermittent: could not reconcile message at this time */
  ReconcileIntermittent = 'ReconcileIntermittent',
  /** ResourceNotFound: resource required for the operation wasn't found */
  ResourceNotFound = 'ResourceNotFound',
  /** TransactionDetailsMissing: transaction details missing */
  TransactionDetailsMissing = 'TransactionDetailsMissing',
  /** Unauthorized: client is not authenticated */
  Unauthorized = 'Unauthorized',
  /** Unexpected: encountered an unexpected error */
  Unexpected = 'Unexpected',
  /** UnsupportedCurrency: currency is not supported */
  UnsupportedCurrency = 'UnsupportedCurrency',
  /** UserIdExists: user has already created a profile */
  UserIdExists = 'UserIdExists',
  /** UserProfileUpdateFailed: failed to update user profile in ddb */
  UserProfileUpdateFailed = 'UserProfileUpdateFailed',
  /** UsernameExists: username has already been registered */
  UsernameExists = 'UsernameExists',
}

export type NovuSubscriberHashResponse = {
  SubscriberHash: Scalars['String'];
};

export type OnchainOut = {
  /** Amount: amount sent */
  Amount: Scalars['Decimal'];
  /**
   * AssetID: for etherum transactions, this should be the smart contract address
   * for the token.
   */
  AssetID?: Maybe<Scalars['String']>;
  /** DestinationAddress: destination address */
  DestinationAddress?: Maybe<DestinationAddress>;
  /**
   * DestinationOut: identify the transfer within the transaction. In the scenario
   * where only one transfer occured then there will be just one instance with a
   * zero index.
   */
  DestinationOut: Scalars['Int'];
};

export type OnchainTransaction = {
  /** Confirmations: number of on-chain confirmation */
  Confirmations: Scalars['Int'];
  /** Outs: transaction destinations */
  Outs?: Maybe<Array<OnchainOut>>;
};

export type OpsCurrencyNetworkConfiguration = {
  /** funding: settings used for the funding and re-balancing of this currency. */
  funding: AppConfigFundingSettings;
  /**
   * minimumSweepAmount: The amount above which the intermediate sweeper will attempt sweeping. Only relevant for account-based currencies.
   * If minimumSweepAmount is not set then sweeping is disabled for the currency.
   */
  minimumSweepAmount?: InputMaybe<Scalars['Decimal']>;
};

/** OrderLimitPolicy: user's order limit policy and usage */
export type OrderLimitPolicy = {
  /** CountLimit: describes a limit on number of transactions */
  CountLimit?: Maybe<CountLimit>;
  /** Network: describes the network to which the limit is applied */
  Network?: Maybe<Network>;
  /** OrderType: describes the type of order */
  OrderType: OrderType;
  /** Period: describes the period of time to which the limit is applied */
  Period: PolicyPeriod;
  /** VolumeLimit: describes a limit on total volume */
  VolumeLimit?: Maybe<VolumeLimit>;
};

/** OrderType: Describes the type of order for currency transfers */
export enum OrderType {
  /** DepositOrder: currency is transferred into the user's account */
  DepositOrder = 'DepositOrder',
  /** WithdrawOrder: currency is transferred out of the user's account */
  WithdrawOrder = 'WithdrawOrder',
}

/** ParamStoreName: Parameter name enum in SSM Parameter Store */
export enum ParamStoreName {
  /** ApplePayMerchantIDCert: Certificate for requesting Apple Pay payment sessions */
  ApplePayMerchantIDCert = 'ApplePayMerchantIDCert',
  /** ApplePayMerchantIDKey: Key for requesting Apple Pay payment sessions */
  ApplePayMerchantIDKey = 'ApplePayMerchantIDKey',
  /** CheckoutPublicKey: Checkout Public Key */
  CheckoutPublicKey = 'CheckoutPublicKey',
  /** CheckoutSecretKey: Checkout Secret Key */
  CheckoutSecretKey = 'CheckoutSecretKey',
  /** FireblocksCosignerCallbackSecretKey: Fireblocks API Co-Signer SGX public key */
  FireblocksApiCosignerSgxPubKey = 'FireblocksApiCosignerSgxPubKey',
  /** FireblocksCosignerCallbackSecretKey: Fireblocks Co-Signer user secret key */
  FireblocksCosignerCallbackSecretKey = 'FireblocksCosignerCallbackSecretKey',
  /** FireblocksEditorApiToken: Token to make Fireblocks API requests */
  FireblocksEditorApiToken = 'FireblocksEditorApiToken',
  /** FireblocksEditorSecretKey: Key to sign Fireblocks API requests */
  FireblocksEditorSecretKey = 'FireblocksEditorSecretKey',
  /** FireblocksWebhookVerifyKey: Key to verify Fireblocks webhook requests */
  FireblocksWebhookVerifyKey = 'FireblocksWebhookVerifyKey',
  /** IntercomIDSecret: Intercom Identity secret */
  IntercomIDSecret = 'IntercomIDSecret',
  /** NomuPayPrivateKey: Private key for signing a NomuPay API requests */
  NomuPayPrivateKey = 'NomuPayPrivateKey',
  /** NovuApiKey: Novu API Key */
  NovuApiKey = 'NovuApiKey',
  /** OryAdminAPIKeyDeveloper: Generated by Ory to authenticate against the developer Ory api */
  OryAdminAPIKeyDeveloper = 'OryAdminAPIKeyDeveloper',
  /** OryAdminApiKey: Generated by Ory to authenticate against the Ory api */
  OryAdminApiKey = 'OryAdminApiKey',
  /** OryOIDCClientSecretApple: Apple OIDC Provider Client Secret */
  OryOIDCClientSecretApple = 'OryOIDCClientSecretApple',
  /** OryOIDCClientSecretGoogle: Google OIDC Provider Client Secret */
  OryOIDCClientSecretGoogle = 'OryOIDCClientSecretGoogle',
  /** OryWebhookApiKey: Generated by NOAH to authenticate Ory Webhooks */
  OryWebhookApiKey = 'OryWebhookApiKey',
  /** QuickNodeToken: The authentication token for QuickNode endpoint */
  QuickNodeToken = 'QuickNodeToken',
  /** QuickNodeTokenPolygon: The authentication token for QuickNode Polygon endpoint */
  QuickNodeTokenPolygon = 'QuickNodeTokenPolygon',
  /** QuickNodeTokenTron: The authentication token for QuickNode Tron endpoint */
  QuickNodeTokenTron = 'QuickNodeTokenTron',
  /** RemiteePassword: Password for Remitee API */
  RemiteePassword = 'RemiteePassword',
  /** RemiteeUsername: Username for Remitee API */
  RemiteeUsername = 'RemiteeUsername',
  /** RevolutApiClientId: Client ID for Revolut API */
  RevolutApiClientId = 'RevolutApiClientId',
  /** RevolutApiPrivateCert: Private certificate for Revolut API */
  RevolutApiPrivateCert = 'RevolutApiPrivateCert',
  /** RevolutApiRefreshToken: Refresh token that allows requesting a new access token */
  RevolutApiRefreshToken = 'RevolutApiRefreshToken',
  /** RevolutWebhookKey: Secret key used to create a HMAC */
  RevolutWebhookKey = 'RevolutWebhookKey',
  /** SardineClientID: Sardine API Client ID */
  SardineClientID = 'SardineClientID',
  /** SardineSecretKey: Sardine API Secret Key */
  SardineSecretKey = 'SardineSecretKey',
  /** ScorechainApiKey: Scorechain API Key */
  ScorechainApiKey = 'ScorechainApiKey',
  /** SegmentApiWriteKey: Segment write key for the client */
  SegmentApiWriteKey = 'SegmentApiWriteKey',
  /** SigningJwtPrivateKey: Private key for signing a JWT used with Signing service */
  SigningJwtPrivateKey = 'SigningJwtPrivateKey',
  /** SubsciptionJwtPrivateKey: Private key for signing a JWT used when setting up GQL subscriptions */
  SubsciptionJwtPrivateKey = 'SubsciptionJwtPrivateKey',
  /** SubsciptionJwtPublicKey: Public key for verifying a signed JWT when setting up GQL subscriptions */
  SubsciptionJwtPublicKey = 'SubsciptionJwtPublicKey',
  /** SumSubApiKey: The authentication token for SumSub API */
  SumSubApiKey = 'SumSubApiKey',
  /** SumSubSecretKey: The secret key for SumSub API */
  SumSubSecretKey = 'SumSubSecretKey',
  /** SumSubWebhookKey: Secret key used to create a HMAC */
  SumSubWebhookKey = 'SumSubWebhookKey',
  /** WoortonOAuthToken: Woorton OAuth token */
  WoortonOAuthToken = 'WoortonOAuthToken',
}

/** ParamStoreNameBitcoin: Bitcoin parameter name prefix for SSM Parameter Store */
export enum ParamStoreNameBitcoin {
  /** BitcoinJsonRpcHost01: Bitcoin JSON-RPC server host in format domain:port */
  BitcoinJsonRpcHost01 = 'BitcoinJsonRpcHost01',
  /** BitcoinJsonRpcPass01: Bitcoin JSON-RPC server password */
  BitcoinJsonRpcPass01 = 'BitcoinJsonRpcPass01',
  /** BitcoinJsonRpcUser01: Bitcoin JSON-RPC server username */
  BitcoinJsonRpcUser01 = 'BitcoinJsonRpcUser01',
}

/** ParamStoreNameBitcoinNode: Bitcoin parameter name suffix for SSM Parameter Store */
export enum ParamStoreNameBitcoinNode {
  /** a: Primary bitcoin node */
  a = 'a',
  /** b: Test wallet bitcoin node */
  b = 'b',
}

/** ParamStoreNameLightning: Lightning parameter name prefix for SSM Parameter Store */
export enum ParamStoreNameLightning {
  /** LightningHost01: Lightning node host in format domain:port */
  LightningHost01 = 'LightningHost01',
  /** LightningMacaroon01: Macaroon to authenticate to a lightning node */
  LightningMacaroon01 = 'LightningMacaroon01',
  /** LightningTlsCert01: Lightning node certificate */
  LightningTlsCert01 = 'LightningTlsCert01',
}

/** ParameterStoreLightningNode: Lightning parameter name suffix for SSM Parameter Store */
export enum ParameterStoreLightningNode {
  /** a: Primary lightning node */
  a = 'a',
  /** b: Test wallet lightning node */
  b = 'b',
}

export type Payment = {
  Created: Scalars['AWSDateTime'];
  Direction: TransactionDirection;
  /** FiatPaymentMethodID: Where should this payment be payed to */
  FiatPaymentMethodID: Scalars['DynamoID'];
  ID: Scalars['DynamoID'];
  /** OrderAmount: The amount of crypto that has been reserved for a payout. TODO: No definition yet for a payin. */
  OrderAmount: Scalars['Decimal'];
  /** OrderCurrency: The crypto currency code the OrderAmount refers to. */
  OrderCurrency: CurrencyCode;
  /** RequestedAmount: The amount and currency to be payed */
  RequestedAmount: FiatAmount;
  Status: PaymentStatus;
  UserID: Scalars['UserID'];
};

export type PaymentComplianceData = {
  /** PaymentPurpose: Purpose of the payment */
  Purpose?: Maybe<Scalars['String']>;
};

export enum PaymentIdentifierType {
  Email = 'Email',
  PhoneNumber = 'PhoneNumber',
  TaxID = 'TaxID',
  UUID = 'UUID',
}

export enum PaymentMethodCategory {
  Bank = 'Bank',
  Card = 'Card',
  Identifier = 'Identifier',
}

export enum PaymentMethodType {
  BankFedwire = 'BankFedwire',
  BankLocal = 'BankLocal',
  BankSepa = 'BankSepa',
  BankSortCode = 'BankSortCode',
  BankSwift = 'BankSwift',
  IdentifierPix = 'IdentifierPix',
  TokenizedCard = 'TokenizedCard',
}

export enum PaymentStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Settled = 'Settled',
}

export enum PaymentStatusEnum {
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  LOCKED = 'LOCKED',
  LOCK_DECLINED = 'LOCK_DECLINED',
  QUOTE_FAILED = 'QUOTE_FAILED',
  REVERSED = 'REVERSED',
  SETTLED = 'SETTLED',
}

export enum PaymentSubStateEnum {
  AVAILABLE = 'AVAILABLE',
  EXPIRED = 'EXPIRED',
  FORWARDED = 'FORWARDED',
  PENDING = 'PENDING',
}

export type Payout = {
  /** EstimateHours: estimated time for the payout to be processed, displayed as a worst case scenario. Null if payout is not supported. */
  EstimateHours?: Maybe<Scalars['Decimal']>;
  /** RawData: raw data of the payout information sent by the provider */
  RawData?: Maybe<Scalars['AWSJSON']>;
};

export type PayoutStatus = {
  Created: Scalars['AWSDateTime'];
  EventType: CkoWebhookType;
  ExecutionRate?: Maybe<MarketPrice>;
  FailureCause?: Maybe<NoahError>;
  ID?: Maybe<Scalars['String']>;
  QuoteID?: Maybe<Scalars['String']>;
  ReferenceID: Scalars['String'];
  Status: PaymentStatusEnum;
  SubState?: Maybe<PaymentSubStateEnum>;
  Updated?: Maybe<Scalars['AWSDateTime']>;
};

/** PolicyPeriod: describes the period of time for which the limit is valid */
export enum PolicyPeriod {
  /** DAY: policy applies to last 24 hours */
  DAY = 'DAY',
  /** SINGLE: policy applies to every transaction */
  SINGLE = 'SINGLE',
}

export type Promotion = {
  /**
   * Amount: amounts of the promotion values per currency.
   * If the user currency is not found, the first Amount in the list will be used as a default value.
   */
  Amounts: Array<FiatAmount>;
  /** Created: created time of the promotion */
  Created: Scalars['AWSDateTime'];
  /** Ends: end time of the promotion */
  Ends: Scalars['AWSDateTime'];
  /** OneTimeUse: whether promotion can only be used once */
  OneTimeUse: Scalars['Boolean'];
  /** PromoID: unique promotion identifier */
  PromoID: Scalars['PromoID'];
  /** PromotionType: what is the promotion applied against */
  PromotionType: PromotionType;
  /** Starts: start time of the promotion */
  Starts: Scalars['AWSDateTime'];
};

/** PromotionClaim: transaction / order ID that the promotion was applied to + amount of promotion applied */
export type PromotionClaim = {
  Amount: FiatAmount;
  ClaimedAt: Scalars['AWSDateTime'];
  ID: Scalars['String'];
};

export enum PromotionType {
  RampFee = 'RampFee',
}

export type PromotionsResponse = {
  UnclaimedPromotions?: Maybe<Array<Promotion>>;
};

export type PubSubEvent = {
  EventName: PubSubEventName;
  NewObject: Scalars['AWSJSON'];
  Occurred: Scalars['AWSDateTime'];
  OldObject?: Maybe<Scalars['AWSJSON']>;
  Source: PubSubEventSource;
  Type: PubSubEventType;
  Version: Scalars['Int'];
};

export enum PubSubEventName {
  Create = 'Create',
  Delete = 'Delete',
  Update = 'Update',
}

export enum PubSubEventSource {
  Api = 'Api',
  Auth = 'Auth',
  DynamoDb = 'DynamoDb',
  Ledger = 'Ledger',
}

export enum PubSubEventType {
  AuthRecovery = 'AuthRecovery',
  AuthSignIn = 'AuthSignIn',
  AuthSignUp = 'AuthSignUp',
  AuthVerification = 'AuthVerification',
  DynamoDbCheckoutSession = 'DynamoDbCheckoutSession',
  DynamoDbCustomer = 'DynamoDbCustomer',
  DynamoDbLiquidityOrder2 = 'DynamoDbLiquidityOrder2',
  DynamoDbQuestCompletion = 'DynamoDbQuestCompletion',
  DynamoDbTransaction = 'DynamoDbTransaction',
  DynamoDbUserConsent = 'DynamoDbUserConsent',
  DynamoDbUserProfile = 'DynamoDbUserProfile',
  DynamoDbWhitelist = 'DynamoDbWhitelist',
  FiatPayment = 'FiatPayment',
  FinServicePayout = 'FinServicePayout',
  LedgerAccount = 'LedgerAccount',
  LedgerAccountBalanceCurrent = 'LedgerAccountBalanceCurrent',
  LedgerRewardTransaction = 'LedgerRewardTransaction',
  LedgerTransaction = 'LedgerTransaction',
  LedgerWithdrawOrder = 'LedgerWithdrawOrder',
  UserClaim = 'UserClaim',
}

export enum PubSubSubscriber {
  QuestEvent = 'QuestEvent',
  ReferralEvent = 'ReferralEvent',
  Segment = 'Segment',
}

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type Query = {
  accounts: AccountsPage;
  apiKeys: Array<ApiKey>;
  cardIssuerNotifications: Array<Maybe<CardIssuerNotification>>;
  customer?: Maybe<Customer>;
  customers: CustomersPage;
  depositAddresses?: Maybe<Array<DepositAddress>>;
  earnedBadges: Array<EarnedBadge>;
  fiatPaymentMethods: FiatPaymentMethods;
  intercomIdentifyHash: IntercomIdentifyHashResponse;
  lightningAddressInvoiceProxy: LightningAddressInvoiceProxyResponse;
  lightningAddressProxy: LightningAddressProxyResponse;
  lightningPaymentRequest: LightningPaymentRequest;
  liquidityPrice: LiquidityPrice;
  marketPrice: MarketPrice;
  novuSubscriberHash: NovuSubscriberHashResponse;
  promotions: PromotionsResponse;
  questsAndBadges: QuestsAndBadgesResponse;
  signingJwt: JwtToken;
  subscriptionJwt: JwtToken;
  transaction?: Maybe<TransactionResponse>;
  transactions: TransactionsPage;
  userEstimateBalance: EstimateBalanceResponse;
  userLimit: UserLimitResponse;
  userProfile: UserProfile;
  userSettingsConsent: Array<Maybe<UserSettingsConsent>>;
  validateReferralCode: Scalars['Boolean'];
  webhookSubscriptions: Array<WebhookSubscription>;
  withdrawFee: WithdrawFee;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryAccountsArgs = {
  Input?: InputMaybe<AccountsInput>;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryCardIssuerNotificationsArgs = {
  Input: CardIssuerNotificationInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryCustomerArgs = {
  Input: CustomerInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryDepositAddressesArgs = {
  Input: DepositAddressesInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryFiatPaymentMethodsArgs = {
  Input?: InputMaybe<FiatPaymentMethodsInput>;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryLightningAddressInvoiceProxyArgs = {
  Input: LightningAddressInvoiceProxyInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryLightningAddressProxyArgs = {
  Input: LightningAddressProxyInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryLightningPaymentRequestArgs = {
  Input: LightningPaymentRequestInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryLiquidityPriceArgs = {
  Input: MarketPriceInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryMarketPriceArgs = {
  Input: MarketPriceInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryTransactionArgs = {
  Input?: InputMaybe<TransactionInput>;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryTransactionsArgs = {
  currencyCode?: InputMaybe<CurrencyCode>;
  filter?: InputMaybe<TransactionsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryUserEstimateBalanceArgs = {
  Input: EstimateBalanceInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryValidateReferralCodeArgs = {
  Input: ValidateReferralCodeInput;
};

/**
 * Always use 'Input' as the root parameter, with input types on top
 * Don't add get / fetch keywords - these are already queries
 */
export type QueryWithdrawFeeArgs = {
  Input: WithdrawFeeInput;
};

/** Quest: quest which can be completed by some users to earn a badge */
export type Quest = {
  /** BadgeTypeID: identifies the type of badge earned from this quest */
  BadgeTypeID?: Maybe<Scalars['BadgeTypeID']>;
  /** Ends: date when thie quest ends */
  Ends?: Maybe<Scalars['AWSDateTime']>;
  /**
   * EndsAfterUserCreatedSec: quest dynamically ends after this many seconds has elapsed after user is created.
   * Does not punish already created users, minimum ending time is Opens + EndsAfterUserCreatedSec.
   */
  EndsAfterUserCreatedSec?: Maybe<Scalars['Int']>;
  /**
   * Features: one of the features is required for the quest to be displayed to user.
   * Default: no features are required.
   */
  Features?: Maybe<Array<Feature>>;
  /**
   * Opens: date from which this quest is displayed to users.
   * Can be after Starts date to allow events prior to Opens date to progress this quest.
   */
  Opens: Scalars['AWSDateTime'];
  /** QuestID: identifies this quest */
  QuestID: Scalars['QuestID'];
  /** RequiredQuestIDs: quests that need to be completed before this one is started */
  RequiredQuestIDs: Array<Scalars['QuestID']>;
  /** Starts: date from which this quest starts */
  Starts: Scalars['AWSDateTime'];
  /** Tasks: tasks */
  Tasks: Array<QuestTask>;
  /** Version: version to increment when updating quest */
  Version: Scalars['Int'];
};

/** QuestCompletion: completion status of quest */
export type QuestCompletion = {
  /** BadgeTypeID: identifies the badge type earned from the quest */
  BadgeTypeID?: Maybe<Scalars['BadgeTypeID']>;
  /** Completed: date when this quest was completed */
  Completed?: Maybe<Scalars['AWSDateTime']>;
  /** Opened: has the quest completion opened to display to users */
  Opened: Scalars['Boolean'];
  /** QuestID: identifies the completed quest */
  QuestID: Scalars['QuestID'];
  /** UserID: identifies the owner of this badge */
  UserID: Scalars['UserID'];
  /** Version: version which is increased when event is handled for quest */
  Version: Scalars['Int'];
};

/** Quest: quest which can be completed by some users to earn a badge */
export type QuestCreateInput = {
  /**
   * BadgeTypeID: identifies the type of badge earned from this quest.
   * Upper/lowercase letters and numbers, 3-25 characters.
   */
  BadgeTypeID?: InputMaybe<Scalars['BadgeTypeID']>;
  /** Ends: date when thie quest ends */
  Ends?: InputMaybe<Scalars['AWSDateTime']>;
  /**
   * EndsAfterUserCreatedSec: quest dynamically ends after this many seconds has elapsed after user is created.
   * Does not punish already created users, minimum ending time is Opens + EndsAfterUserCreatedSec.
   */
  EndsAfterUserCreatedSec?: InputMaybe<Scalars['Int']>;
  /**
   * Features: one of the features is required for the quest to be displayed to user.
   * Default: no features are required.
   */
  Features?: InputMaybe<Array<Feature>>;
  /**
   * Opens: date from which this quest is displayed to users.
   * Can be after Starts date to allow events prior to Opens date to progress this quest.
   */
  Opens: Scalars['AWSDateTime'];
  /**
   * QuestID: identifies the quest.
   * Upper/lowercase letters and numbers, 3-25 characters.
   */
  QuestID: Scalars['QuestID'];
  /** RequiredQuestIDs: quests that need to be completed before this one is started */
  RequiredQuestIDs: Array<Scalars['QuestID']>;
  /** Starts: date from which this quest starts */
  Starts: Scalars['AWSDateTime'];
  /** Tasks: tasks */
  Tasks: Array<QuestTaskCreateInput>;
  /** Version: version to increment when updating quest */
  Version: Scalars['Int'];
};

/** QuestProgress: user's status for a quest */
export type QuestStatus = {
  /**
   * Progress: how many tasks user has completed or, for a sinle-task quest, task progress count of the task.
   * Equal to RequiredProgress if user has completed the quest.
   */
  Progress: Scalars['Int'];
  /** Quest: quest */
  Quest: Quest;
  /** RequiredProgress: how many tasks are in the quest or, for a sinle-task quest, required count of the task */
  RequiredProgress: Scalars['Int'];
  /** Tasks: quest's tasks with user's current progress of the task, null if quest has been completed */
  Tasks?: Maybe<Array<QuestTaskWithStatus>>;
};

/** QuestTask: task which can reward NOAH and count towards a quest */
export type QuestTask = {
  /** Code: code that must be provided */
  Code?: Maybe<Scalars['String']>;
  /** DestinationType: type of transfer destination */
  DestinationType?: Maybe<TransferDestinationType>;
  /** FiatCurrencyCode: fiat currency that the required amount is counted in */
  FiatCurrencyCode?: Maybe<FiatCurrencyCode>;
  /** IsAmountCumulative: is event amount counted towards required amount cumulatively */
  IsAmountCumulative?: Maybe<Scalars['Boolean']>;
  /** QuestTaskID: identifier of this task */
  QuestTaskID: Scalars['QuestTaskID'];
  /**
   * RequiredAmount: amount required to make the action count
   * * Deposit requirement: amount of money that needs to be deposited
   */
  RequiredAmount?: Maybe<Scalars['Decimal']>;
  /** RequiredCount: how many times the requirement needs to be fulfilled */
  RequiredCount: Scalars['Int'];
  /**
   * RequiredCurrencyCode: currency associated with the task
   * * Deposit requirement: currency that needs to be deposited
   */
  RequiredCurrencyCode?: Maybe<CurrencyCode>;
  /** Requirement: requirement to complete this task */
  Requirement: QuestTaskRequirement;
  /** RewardHold: reward is not dispersed */
  RewardHold?: Maybe<Scalars['Boolean']>;
  /** RewardNoah: amount of NOAH rewarded for task */
  RewardNoah: Scalars['Decimal'];
  /** SourceTypes: type of transfer source */
  SourceTypes?: Maybe<Array<TransferSourceType>>;
  /** Sources: source of the event */
  Sources?: Maybe<Array<Scalars['String']>>;
};

/** QuestTaskCreateInput: task which can reward NOAH and count towards a quest */
export type QuestTaskCreateInput = {
  /** Code: code that must be provided */
  Code?: InputMaybe<Scalars['String']>;
  /** DestinationType: type of transfer destination */
  DestinationType?: InputMaybe<TransferDestinationType>;
  /** FiatCurrencyCode: fiat currency that the required amount is counted in */
  FiatCurrencyCode?: InputMaybe<FiatCurrencyCode>;
  /** IsAmountCumulative: is event amount counted towards required amount cumulatively */
  IsAmountCumulative?: InputMaybe<Scalars['Boolean']>;
  /**
   * RequiredAmount: amount required to make the action count
   * * Deposit requirement: amount of money that needs to be deposited
   */
  RequiredAmount?: InputMaybe<Scalars['Decimal']>;
  /** RequiredCount: how many times the requirement needs to be fulfilled */
  RequiredCount: Scalars['Int'];
  /**
   * RequiredCurrencyCode: currency associated with the task
   * * Deposit requirement: currency that needs to be deposited
   */
  RequiredCurrencyCode?: InputMaybe<CurrencyCode>;
  /** Requirement: requirement to complete this task */
  Requirement: QuestTaskRequirement;
  /** RewardHold: reward is not dispersed */
  RewardHold?: InputMaybe<Scalars['Boolean']>;
  /** RewardNoah: amount of NOAH rewarded for task */
  RewardNoah: Scalars['Decimal'];
  /** SourceTypes: type of transfer source */
  SourceTypes?: InputMaybe<Array<TransferSourceType>>;
  /** Sources: source of the event */
  Sources?: InputMaybe<Array<Scalars['String']>>;
};

/** QuestTaskRequirement: requirement to complete a task */
export enum QuestTaskRequirement {
  /** Claim: user has used a claim code, action based */
  Claim = 'Claim',
  /** CreateLightningInvoice: user creates a lightning invoice, action based */
  CreateLightningInvoice = 'CreateLightningInvoice',
  /** Deposit: deposit to Noah, action based */
  Deposit = 'Deposit',
  /** LightningInvoiceSettled: user's lightning invoice is settled, action based */
  LightningInvoiceSettled = 'LightningInvoiceSettled',
  /** MarketingSignup: user has signed up to marketing emails, state based */
  MarketingSignup = 'MarketingSignup',
  /** Referrals: amount of referrals user makes, action based */
  Referrals = 'Referrals',
  /** RegisterLightningAddress: user has registered a lightning address, state based */
  RegisterLightningAddress = 'RegisterLightningAddress',
  /** TotalReferrals: amount of referrals user has made, state based */
  TotalReferrals = 'TotalReferrals',
  /** UserSignup: user has signed up, state based */
  UserSignup = 'UserSignup',
  /** VerifyEmail: user has verified email, state based */
  VerifyEmail = 'VerifyEmail',
  /** Withdraw: withdraw from Noah, action based */
  Withdraw = 'Withdraw',
}

/** QuestTaskStatus: user status of a quest task */
export type QuestTaskStatus = {
  /** Count: count of actions user completed */
  Count: Scalars['Int'];
  /** CumulatedAmount: amount that user has accumulated */
  CumulatedAmount?: Maybe<Scalars['Decimal']>;
  /** QuestTaskID: identifies quest task */
  QuestTaskID: Scalars['QuestTaskID'];
  /** Started: date when task progress started */
  Started: Scalars['AWSDateTime'];
  /** UserID: identifies the user performing the quest task */
  UserID: Scalars['UserID'];
};

/** QuestTaskAndStatus: quest task and user status of the task */
export type QuestTaskWithStatus = {
  /** Task: quest task */
  Task: QuestTask;
  /** TaskStatus: user status of the task, null if task has not been progressed */
  TaskStatus?: Maybe<QuestTaskStatus>;
};

/** QuestsAndBadgesResponse: user's quest status */
export type QuestsAndBadgesResponse = {
  /** QuestStatuses: progress of quests available for user */
  QuestStatuses: Array<QuestStatus>;
  /** UserBadges: locked and earned status for the user */
  UserBadges: Array<UserBadge>;
};

/** ReconciliationBalance: Balance at a reconciliation step */
export type ReconciliationBalance = {
  /** Available: Available balance after this step */
  Available: Scalars['Decimal'];
  /** OpeningAvailable: Available balance prior to this step */
  OpeningAvailable: Scalars['Decimal'];
  /** OpeningTotal: Total balance prior to this step */
  OpeningTotal: Scalars['Decimal'];
  /** Total: Total balance after this step */
  Total: Scalars['Decimal'];
};

/** ReconciliationResult: Describes the result of a reconciliation step */
export type ReconciliationResult = {
  Created: Scalars['AWSDateTime'];
  /** Description: additional description */
  Description?: Maybe<Scalars['String']>;
  /** DestinationBalance: Destination account balance */
  DestinationBalance?: Maybe<ReconciliationBalance>;
  Error?: Maybe<NoahError>;
  /** Skipped: step was invoked but it was disabled */
  Skipped?: Maybe<Scalars['Boolean']>;
  /** SourceBalance: Source account balance */
  SourceBalance?: Maybe<ReconciliationBalance>;
  Type: ReconciliationTask;
};

export enum ReconciliationTask {
  BroadcastTransaction = 'BroadcastTransaction',
  CheckOnchainRisk = 'CheckOnchainRisk',
  CheckPolicy = 'CheckPolicy',
  CheckUserRisk = 'CheckUserRisk',
  Correction = 'Correction',
  DepositOrder = 'DepositOrder',
  DepositTransaction = 'DepositTransaction',
  ExpireTransaction = 'ExpireTransaction',
  FailureTransaction = 'FailureTransaction',
  FiatPaymentTransaction = 'FiatPaymentTransaction',
  FinaliseTransaction = 'FinaliseTransaction',
  InitiateOrder = 'InitiateOrder',
  InitiateTransaction = 'InitiateTransaction',
  InternalTransaction = 'InternalTransaction',
  InvoiceTransaction = 'InvoiceTransaction',
  ManageLiquidity = 'ManageLiquidity',
  MarketAmount = 'MarketAmount',
  PaymentTransaction = 'PaymentTransaction',
  Promotion = 'Promotion',
  ReversalTransaction = 'ReversalTransaction',
  RollbackTransaction = 'RollbackTransaction',
  TransactionCosigner = 'TransactionCosigner',
  ValidateCommit = 'ValidateCommit',
  ValidateContract = 'ValidateContract',
  ValidateDestination = 'ValidateDestination',
  ValidateNonCustody = 'ValidateNonCustody',
  ValidateOnchain = 'ValidateOnchain',
  ValidateStructure = 'ValidateStructure',
  WithdrawTransaction = 'WithdrawTransaction',
}

export type RemiteeDebtor = {
  fullName: FullNameInput;
  idNumber: Scalars['String'];
  idType: IdentityType;
  postalAddress: StreetAddressInput;
};

export type RevolutAccount = {
  AccountID: Scalars['String'];
  CounterpartyID: Scalars['String'];
  FinService: FinService;
  Reference: Scalars['String'];
};

/**
 * RevolutAccountCreateInput: inputs for creating a counterparty in Revolut and an Account in our system.
 * For required fields depending on the country, see:
 * https://developer.revolut.com/docs/guides/manage-accounts/tutorials/create-a-counterparty#required-details-depending-on-the-country
 */
export type RevolutAccountCreateInput = {
  AccountDetails: CounterpartyInput;
  FinService: FinService;
  Reference: Scalars['String'];
};

/** RewardActivity: Noah rewards activity */
export enum RewardActivity {
  /** EarlyUser: rewards accrued by signing up with Noah early on and referring early */
  EarlyUser = 'EarlyUser',
  /** QuestTask: rewards accrued by completing a quest task */
  QuestTask = 'QuestTask',
  /** Referral: reward accrual by referring a person to signup with Noah */
  Referral = 'Referral',
  /** Referred: reward accrual by signing up with Noah using a referral */
  Referred = 'Referred',
  /**
   * ReferredSignup: reward accrual by signing up with Noah using a referral
   *
   * @deprecated Reward comes from Onboarding quest and Referred activity
   */
  ReferredSignup = 'ReferredSignup',
  /**
   * Signup: reward accrual by signing up with Noah
   *
   * @deprecated Reward comes from Onboarding quest
   */
  Signup = 'Signup',
}

/**
 * RewardTransaction:
 * Describes internal reward transactions that are committed to our ledger.
 */
export type RewardTransaction = {
  /** Activity: activity that caused this transaction */
  Activity: RewardActivity;
  /** ActivityCount: count of times the activity was performed */
  ActivityCount: Scalars['Int'];
  /** Amount: the incoming or outgoing absolute amount of the transaction (i.e. no -ve numbers) */
  Amount: Scalars['Decimal'];
  /** Currency: the currency type of the transaction */
  Currency: CurrencyCode;
  /** DestinationAccountID: identifies the destination account ID */
  DestinationAccountID?: Maybe<Scalars['AccountID']>;
  NoahID: Scalars['NoahID'];
  /** QuestTaskID: task id for reward with quest task activity */
  QuestTaskID?: Maybe<Scalars['QuestTaskID']>;
  /** ReversedBy: transaction that reverses this transaction */
  ReversedBy?: Maybe<Scalars['NoahID']>;
  /** Reverses: transaction that this transaction reverses */
  Reverses?: Maybe<Scalars['NoahID']>;
  /** SourceAccountID: identifies the source account ID */
  SourceAccountID?: Maybe<Scalars['AccountID']>;
  /** Status: the current status of the transaction on the Noah Ledger */
  Status: TransactionStatus;
  /** Steps: is a record of the outcome of our validation & verification steps */
  Steps: RewardTransactionSteps;
};

/** RewardTransactionStepSource: an enum describing the supported service types */
export enum RewardTransactionStepSource {
  Quest = 'Quest',
  Signup = 'Signup',
}

/** RewardTransactionSteps: is a record of the outcome of our validation & verification steps */
export type RewardTransactionSteps = {
  Quest: Array<ReconciliationResult>;
  Signup: Array<ReconciliationResult>;
};

/** RewardsIndexedFields: index fields on ledger rewards table */
export enum RewardsIndexedFields {
  DestinationAccountID = 'DestinationAccountID',
  ID = 'ID',
  NoahID = 'NoahID',
}

export enum RpcImplementation {
  BtcRpc = 'BtcRpc',
  Geth = 'Geth',
}

export type Rule = {
  Actions: Array<Maybe<Action>>;
  Created: Scalars['AWSDateTime'];
  ExpiresAt?: Maybe<Scalars['AWSDateTime']>;
  ID: Scalars['ID'];
  Status: RuleStatus;
  Trigger: Trigger;
  TriggerIndex: Scalars['String'];
};

export enum RuleStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Paused = 'Paused',
}

export type S3 = {
  customerBucketName: Scalars['String'];
};

export type SardineDevicesResponse = {
  Success: Scalars['Boolean'];
};

export enum SardineFlows {
  BankSell = 'BankSell',
  CheckoutBuy = 'CheckoutBuy',
  CheckoutSell = 'CheckoutSell',
  CryptoWithdraw = 'CryptoWithdraw',
  Dashboard = 'Dashboard',
  Registration = 'Registration',
  id_verification = 'id_verification',
}

export type SegmentSubscription = {
  groups: Array<SegmentSubscriptionGroup>;
  /** key: user's email address */
  key: Scalars['String'];
  status: SegmentSubscriptionGroupStatus;
  type: SegmentSubscriptionGroupType;
};

export type SegmentSubscriptionGroup = {
  name: SegmentSubscriptionGroupName;
  status: SegmentSubscriptionGroupStatus;
};

export enum SegmentSubscriptionGroupName {
  Marketing = 'Marketing',
  Operational = 'Operational',
}

export enum SegmentSubscriptionGroupStatus {
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum SegmentSubscriptionGroupType {
  EMAIL = 'EMAIL',
}

export type SellAction = Action & {
  AuthorizedAmount: StepDecimal;
  ChannelID?: Maybe<Scalars['UUID']>;
  CryptoCurrency: Scalars['String'];
  CustomerID?: Maybe<Scalars['CustomerID']>;
  ExternalID?: Maybe<Scalars['String']>;
  FiatAmount: StepDecimal;
  PaymentMethodID?: Maybe<Scalars['String']>;
  Type: ActionType;
};

export type Session = {
  AuthorizedAmount?: Maybe<Scalars['Decimal']>;
  CheckoutSessionID: Scalars['ID'];
  Created: Scalars['AWSDateTime'];
  CustomerID: Scalars['CustomerID'];
  DestinationAmount?: Maybe<Scalars['Decimal']>;
  DestinationCurrency: Scalars['AssetID'];
  Expiry: Scalars['AWSDateTime'];
  ExternalID?: Maybe<Scalars['ID']>;
  ItemDescription?: Maybe<Scalars['String']>;
  PaymentMethodCategory?: Maybe<PaymentMethodCategory>;
  ReturnURL: Scalars['String'];
  SourceAmount?: Maybe<Scalars['Decimal']>;
  SourceCurrency: Scalars['AssetID'];
  Status: CheckoutStatus;
  UserID: Scalars['UserID'];
};

export type SettlePaymentInput = {
  ID: Scalars['DynamoID'];
  MarketAmount: FiatAmountInput;
};

export type SettlePaymentResponse = {
  Status: PaymentStatus;
};

/** SigningDocumentType: type indicating what a key managed by Signing service is for */
export enum SigningDocumentType {
  /** NonCustodyKey: key that user signs withdraw orders with */
  NonCustodyKey = 'NonCustodyKey',
}

/** SigningKey: public key of a key that user has control of and that user manages with Signing service */
export type SigningKey = {
  /** CreatedAt: when the key was created by user in the Signing service */
  CreatedAt: Scalars['AWSDateTime'];
  /** DocumentType: type indicating what the key is for */
  DocumentType: SigningDocumentType;
  /** ID: ID of a user signing key, of the form <UserID>/<SigningDocumentType> */
  ID: Scalars['SigningKeyID'];
  /** KeyAlgorithm: key algorithm used when verifying user signatures */
  KeyAlgorithm: SigningKeyAlgorithm;
  /** PublicKey: key used to verify user signatures */
  PublicKey: Scalars['String'];
  /**
   * Seq: sequence number of the key.
   * For NonCustodyKey the key with the highest seq is the active key.
   */
  Seq: Scalars['Int'];
  /** Tag that uniquely identifies the the signing key, 32 bytes */
  Tag: Scalars['String'];
  /** UserID: user that controls the private key */
  UserID: Scalars['UserID'];
};

/** SigningKeyAlgorithm: asymmetric key algorithm supported by Signing service */
export enum SigningKeyAlgorithm {
  /** Secp256k1: algorithm commoly used for Bitcoin */
  Secp256k1 = 'Secp256k1',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** SourceAddress: the origin location of a transaction */
export type SourceAddress = {
  /** Address: the wallet address of the transaction */
  Address: Scalars['Address'];
};

export type StepDecimal = {
  Operations?: Maybe<Array<StepDecimalOperation>>;
  Value: Scalars['String'];
};

export type StepDecimalOperation = {
  Operator: StepDecimalOperator;
  Value: Scalars['String'];
};

export enum StepDecimalOperator {
  Add = 'Add',
  Mul = 'Mul',
  Sub = 'Sub',
}

/** StepFnEvent: Describes the shape of inputs and outputs between step functions. */
export type StepFnEvent = {
  /** ErrorCatch: captures the error on step function failure */
  ErrorCatch?: Maybe<ErrorCatch>;
  /** EventID: id unique for the step function execution */
  EventID: Scalars['EventID'];
  /** ExpiryTime: time of expiry */
  ExpiryTime?: Maybe<Scalars['AWSDateTime']>;
  /** FailureStep: records the step which failed so it can be recorded and / or used in error handlers. */
  FailureStep?: Maybe<FailureStep>;
  /** IsCompletedTransaction: is the transaction completed */
  IsCompletedTransaction: Scalars['Boolean'];
  /** IsDepositTransaction: does the transaction deposit currency to user wallet */
  IsDepositTransaction: Scalars['Boolean'];
  /** IsDuplicate: is the event a duplicate */
  IsDuplicate: Scalars['Boolean'];
  /** IsFailure: is the event a failure */
  IsFailure: Scalars['Boolean'];
  /** IsInternalTransaction: is the transaction to be settled internally */
  IsInternalTransaction: Scalars['Boolean'];
  /**
   * IsManualTransaction: does the transaction need manual intervention. If true
   * it means that there is some human intervention required to complete the
   * transaction.
   */
  IsManualTransaction: Scalars['Boolean'];
  /** IsMarketAmountSet: is market amount already set on transaction */
  IsMarketAmountSet: Scalars['Boolean'];
  /** IsPendingTransaction: is the transaction still pending */
  IsPendingTransaction: Scalars['Boolean'];
  /** IsWithdrawTransaction: does the transaction withdraw currency from user wallet */
  IsWithdrawTransaction: Scalars['Boolean'];
  /** NoahID: id of a transaction event */
  NoahID?: Maybe<Scalars['NoahID']>;
  /** PublicID: public blockchain transaction id or hash */
  PublicID?: Maybe<Scalars['PublicID']>;
  /** RawEvent: unmodified event that started the step function */
  RawEvent: Scalars['AWSJSON'];
  /** Status: the current status of the transaction. Used by the state machine to know when to stop or fail. */
  Status: TransactionStatus;
  /** UserSessionID: unique identifier of user authentication session */
  UserSessionID?: Maybe<Scalars['String']>;
  /** WithdrawOrderID: id of a withdraw order event */
  WithdrawOrderID?: Maybe<Scalars['WithdrawOrderID']>;
};

export type StreetAddress = {
  /** City: name of an address's city or town. */
  City: Scalars['String'];
  /** CountryCode: user's country code */
  CountryCode: Scalars['CountryCode'];
  /** PostCode: the address's postcode */
  PostCode: Scalars['String'];
  /** State: the address's state / province / county */
  State: Scalars['String'];
  /** Street: the primary name of an address's street. */
  Street: Scalars['String'];
  /** Street2: the secondary name of an address's street. */
  Street2?: Maybe<Scalars['String']>;
};

export type StreetAddressInput = {
  /** City: name of an address's city or town. */
  City: Scalars['String'];
  /** CountryCode: user's country code */
  CountryCode: Scalars['CountryCode'];
  /** PostCode: the address's postcode */
  PostCode: Scalars['String'];
  /** State: the address's state / province / county */
  State: Scalars['String'];
  /** Street: the primary name of an address's street. */
  Street: Scalars['String'];
  /** Street2: the secondary name of an address's street. */
  Street2?: InputMaybe<Scalars['String']>;
};

/** SubAccountResponse: wrapper for publishing account updates to the app. */
export type SubAccountResponse = {
  Data: AccountResponse;
  UserID: Scalars['UserID'];
};

export type Subscription = {
  onAccountUpdate?: Maybe<SubAccountResponse>;
};

export type SumSubAccessTokenInput = {
  /** LevelName: A name of the level configured in the dashboard */
  LevelName: Scalars['String'];
};

/** SumSubAccessTokenResponse: returns an access token for applicant, it’s only valid for 1 applicant and can't access other applicants */
export type SumSubAccessTokenResponse = {
  /** Token: Access token for the SDK */
  Token: Scalars['String'];
  /** UserID: UserID for which the token was created */
  UserID: Scalars['UserID'];
};

export type SuspendState = {
  ID: Scalars['String'];
  TaskToken: Scalars['String'];
};

export enum SystemStatus {
  /** Active: system is functioning normally */
  Active = 'Active',
  /** Locked: system has a problem and all features will be disabled (e.g. system is under attack) */
  Locked = 'Locked',
  /** Maintenance: system is in maintenance mode and all features will be disabled */
  Maintenance = 'Maintenance',
}

export enum TransactionDirection {
  In = 'In',
  Out = 'Out',
}

export type TransactionFiatPayment = {
  /**
   * Amount: the final amount that has been debited (for buy transactions) or
   * credited (for sell transactions) from the payment method.
   */
  Amount: Scalars['Decimal'];
  /**
   * FeeAmount: The fee applied to this payment. For buy transactions, this value
   * is included in `Amount`. For sell transactions, this value is excluded from
   * the `Amount`.
   */
  FeeAmount: Scalars['Decimal'];
  /** FiatCurrency: The currency related to the amounts. */
  FiatCurrency: FiatCurrencyCode;
  /** Rate: Crypto/Fiat exchange rate. */
  Rate?: Maybe<Scalars['Decimal']>;
};

export type TransactionInput = {
  /** TransactionID: the unique identifier of this transaction can be either NoahID or WithdrawOrderID */
  TransactionID: Scalars['String'];
};

export type TransactionMetadata = {
  /** ExternalID: the unique identifier of this transaction on the external system */
  ExternalID?: Maybe<Scalars['String']>;
  /** TransactionID: id of the transaction this metadata belongs to */
  TransactionID: Scalars['String'];
  /** UserID: ID of source or destination user */
  UserID: Scalars['UserID'];
};

/** TransactionOperation: Operation of transaction */
export enum TransactionOperation {
  /** Mint: Mint new tokens */
  Mint = 'Mint',
  /** Transfer: Transfer funds */
  Transfer = 'Transfer',
}

/** TransactionRecord: a record of an operation performed on a transaction */
export type TransactionRecord = {
  /** Amount: resulting amount of the operation */
  Amount: Scalars['Decimal'];
  /** Asset: asset of the operation */
  Asset?: Maybe<Scalars['AssetID']>;
  /**
   * FiatCurrency: resulting fiat currency of the operation.
   *
   * @deprecated Use AssetID insead.
   */
  FiatCurrency?: Maybe<FiatCurrencyCode>;
  /** Rate: rate used to perform the operation */
  Rate?: Maybe<Scalars['Decimal']>;
  /** RecordType: type of operation */
  RecordType: TransactionRecordType;
};

export enum TransactionRecordType {
  /** Fee: fee taken to system funding */
  Fee = 'Fee',
  /** NetworkFee: fee taken to cover network transaction costs */
  NetworkFee = 'NetworkFee',
}

/** TransactionResponse: transaction from DDB */
export type TransactionResponse = {
  /** Amount: The net crypto amount transacted, affecting the balance. This amount **excludes** the `NetworkFee`. For buy transactions, this is the amount after payment fees. For sell transactions, this is the amount before payment fees. */
  Amount: Scalars['Decimal'];
  /** AmountUSD: the usd amount (i.e. the usd amount from the fireblocks transaction) */
  AmountUSD?: Maybe<Scalars['String']>;
  /** Created: date when the transaction was created */
  Created: Scalars['AWSDateTime'];
  /** Currency: the currency type of the transaction */
  Currency: CurrencyCode;
  /** CustomerID: ID of the customer for this transaction */
  CustomerID?: Maybe<Scalars['CustomerID']>;
  /** Description: text attached to this transaction */
  Description?: Maybe<Scalars['String']>;
  /** Destination: the end location of this transaction */
  Destination?: Maybe<DestinationAddress>;
  /** DestinationAccountID: identifies the destination account ID */
  DestinationAccountID?: Maybe<Scalars['AccountID']>;
  /** DestinationRecords: records of operations perfomed on a destination transaction */
  DestinationRecords?: Maybe<Array<TransactionRecord>>;
  /** Destination Type: type of destination */
  DestinationType?: Maybe<TransferDestinationType>;
  /** DestinationUsernameDisplay: the receiver UsernameDisplay if the destination address belongs to a NOAH user */
  DestinationUsernameDisplay?: Maybe<Scalars['String']>;
  /** Direction: whether the funds were added/credited or subtracted/debited from the user balance */
  Direction?: Maybe<TransactionDirection>;
  /** DynamoID: DynamoID of the transaction */
  DynamoID: Scalars['DynamoID'];
  /** Expiry: time from which the transaction cannot be paid anymore */
  Expiry?: Maybe<Scalars['AWSDateTime']>;
  /** ExternalID: the unique identifier of this transaction on the external system */
  ExternalID?: Maybe<Scalars['String']>;
  /** FiatPayment: When the transaction is a sell or buy this attributed is set. */
  FiatPayment?: Maybe<TransactionFiatPayment>;
  /**
   * MarketAmount: amount of fiat that the crypto was worth at the time transaction was
   * committed to ledger
   */
  MarketAmount?: Maybe<FiatAmount>;
  /** Network: Network of the transaction */
  Network: Network;
  /** NetworkFee: Amount paid to cover the network costs. */
  NetworkFee?: Maybe<Scalars['Decimal']>;
  /** NoahID: the unique identifier of this transaction */
  NoahID?: Maybe<Scalars['NoahID']>;
  /** Operation: Operation of the transaction, such as Transfer */
  Operation?: Maybe<TransactionOperation>;
  /** Origin: the origin of activity transaction */
  Origin?: Maybe<EventOrigin>;
  /** PublicID: the unique identifier of this transaction */
  PublicID?: Maybe<Scalars['PublicID']>;
  /**
   * RequestedAmount: amount of fiat that user requested to transact.
   * This amount is informative and can be manipulated by user.
   * Market and order amounts are expected to be near this number but
   * this might be what user expects to see and user might be easiser to read.
   */
  RequestedAmount?: Maybe<FiatAmount>;
  /** Reverses: transaction that this transaction reverses (may reverse partially) */
  Reverses?: Maybe<Scalars['NoahID']>;
  /** Source: the origin location of this transaction */
  Source?: Maybe<SourceAddress>;
  /** SourceAccountID: identifies the source account ID */
  SourceAccountID?: Maybe<Scalars['AccountID']>;
  /** SourceRecords: records of operations perfomed on a source transaction */
  SourceRecords?: Maybe<Array<TransactionRecord>>;
  /** SourceType: type of the source */
  SourceType?: Maybe<TransferSourceType>;
  /** SourceUsernameDisplay: the sender UsernameDisplay if the source address belongs to a NOAH user */
  SourceUsernameDisplay?: Maybe<Scalars['String']>;
  /** Status: the current status of the transaction on the Noah Ledger */
  Status: TransactionStatus;
  /** WithdrawOrderID: id of an original withdraw order, if related */
  WithdrawOrderID?: Maybe<Scalars['WithdrawOrderID']>;
};

export enum TransactionStatus {
  /** Failed: The transaction has failed processing */
  Failed = 'Failed',
  /** Pending: The transaction is being processed */
  Pending = 'Pending',
  /** Settled: The transaction has been processed and found to be correct */
  Settled = 'Settled',
}

/** TransactionStepSource: an enum describing the supported service types */
export enum TransactionStepSource {
  Checkout = 'Checkout',
  Core = 'Core',
  Deposit = 'Deposit',
  Fireblocks = 'Fireblocks',
  Invoice = 'Invoice',
  Lnd = 'Lnd',
  Moonpay = 'Moonpay',
  Payment = 'Payment',
  Ramp = 'Ramp',
  Signing = 'Signing',
  Withdraw = 'Withdraw',
}

/** TransactionSteps: is a record of the outcome of our validation & verification steps */
export type TransactionSteps = {
  /** Checkout: transaction steps from a cko event */
  Checkout: Array<ReconciliationResult>;
  /** Core: additional core steps */
  Core: Array<ReconciliationResult>;
  /** Deposit: transaction steps from initiating a deposit */
  Deposit: Array<ReconciliationResult>;
  /** Fireblocks: transaction steps from a Fireblocks event */
  Fireblocks: Array<ReconciliationResult>;
  /** Invoice: transaction steps from invoicing */
  Invoice: Array<ReconciliationResult>;
  /** Lnd: transaction steps from a lightning node event */
  Lnd: Array<ReconciliationResult>;
  /**
   * Moonpay: transaction steps from a Moonpay event
   *
   * @deprecated Moonpay is deprecated and should not be used.
   */
  Moonpay: Array<ReconciliationResult>;
  /** Payment: transaction steps from sending a payment */
  Payment: Array<ReconciliationResult>;
  /** Ramp: transactions steps from the ramp engine */
  Ramp: Array<ReconciliationResult>;
  /** Signing: signing service steps */
  Signing: Array<ReconciliationResult>;
  /** Withdraw: transaction steps from initiating a withdrawal */
  Withdraw: Array<ReconciliationResult>;
};

export type TransactionsFilter = {
  AccountType?: InputMaybe<ModelStringInput>;
  Amount?: InputMaybe<ModelDecimalInput>;
  Currency?: InputMaybe<ModelStringInput>;
  Destination?: InputMaybe<ModelDestinationInput>;
  SourceAccountID?: InputMaybe<ModelStringInput>;
  SourceType?: InputMaybe<ModelStringInput>;
  Status?: InputMaybe<ModelStringInput>;
  and?: InputMaybe<Array<InputMaybe<TransactionsFilter>>>;
  not?: InputMaybe<TransactionsFilter>;
  or?: InputMaybe<Array<InputMaybe<TransactionsFilter>>>;
};

/** TransactionsIndexedFields: index fields on ledger transactions table */
export enum TransactionsIndexedFields {
  NoahID = 'NoahID',
  PublicID = 'PublicID',
}

export type TransactionsPage = {
  items?: Maybe<Array<TransactionResponse>>;
  nextToken?: Maybe<Scalars['String']>;
};

/** TransferDestination: transfer transaction destination */
export type TransferDestination = {
  /**
   * DestinationAddress: destination address (address + optional ref).
   * Only needed if DestinationType is Address
   */
  DestinationAddress?: InputMaybe<DestinationAddressInput>;
  /** DestinationType: determines type of transfer */
  DestinationType: TransferDestinationType;
  /** ID: if DestinationType is Whitelist then use the Whitelisted AddressID, if Moonpay use the Moonpay transactionID. */
  ID?: InputMaybe<Scalars['String']>;
};

/** TransferDestinationType: type of transfer destination */
export enum TransferDestinationType {
  /** Address: withdrawals to an address */
  Address = 'Address',
  /** Bitrefill: withrawals to pay Bitrefill orders */
  Bitrefill = 'Bitrefill',
  /** Channel: sell transactions that should go through a channel */
  Channel = 'Channel',
  /** Checkout: withrawals to pay Checkout orders */
  Checkout = 'Checkout',
  /** ManualRamp: withrawal to fund a ManualRamp payout transaction */
  ManualRamp = 'ManualRamp',
  /**
   * Moonpay: withrawals to pay Moonpay orders
   *
   * @deprecated Moonpay should not be used and is deprecated
   */
  Moonpay = 'Moonpay',
  /** Whitelist: withdrawals to a user's whitelisted address */
  Whitelist = 'Whitelist',
}

/** TransferDestinationTypeInput: transfer destination input */
export enum TransferDestinationTypeInput {
  /** Bitrefill: withrawals to pay Bitrefill orders */
  Bitrefill = 'Bitrefill',
}

/** TransferSourceType: type of transfer source */
export enum TransferSourceType {
  /** Checkout: transfers from Cko payment requests. CORE-620 - rename to Cko */
  Checkout = 'Checkout',
  /** ManualRamp: transfers from manual ramp payin */
  ManualRamp = 'ManualRamp',
  /**
   * Moonpay: transfers for Moonpay sell orders
   *
   * @deprecated Moonpay should not be used and is deprecated
   */
  Moonpay = 'Moonpay',
}

export type Trigger = {
  Type: TriggerType;
};

export enum TriggerType {
  DepositDestination = 'DepositDestination',
  DepositSource = 'DepositSource',
}

export type UserAppSettingsUpdateInput = {
  DisplayUnit?: InputMaybe<CurrencyUnit>;
  FiatCurrencyCode?: InputMaybe<FiatCurrencyCode>;
  PrimaryCurrency?: InputMaybe<CurrencyDisplayType>;
};

/** UserBadge: badge that user has earned */
export type UserBadge = {
  /** BadgeTypeID: identifies the type of this badge */
  BadgeTypeID: Scalars['BadgeTypeID'];
  /** Difficulty: difficulty of the quest granting this badge */
  Difficulty: Scalars['Int'];
  /** Earned: date when this badge was earned */
  Earned?: Maybe<Scalars['AWSDateTime']>;
  /** QuestID: the ID of the quest granting this badge */
  QuestID?: Maybe<Scalars['QuestID']>;
};

/** UserClaim: claim that user is making */
export type UserClaim = {
  /** ClaimType: claim type being made */
  Code: Scalars['String'];
  /** UserID: user making the claim */
  UserID: Scalars['UserID'];
};

export type UserComplianceState = {
  Modified: Scalars['AWSDateTime'];
  /** ModifiedBy: the identifier of the user who changed this status (comes from Retool) */
  ModifiedBy: Scalars['String'];
  /** Reason: a Linear ticket number. Must be in the format "COM-5****' where **** are optional numbers */
  Reason: Scalars['String'];
  Status: UserComplianceStatus;
};

export type UserComplianceStateInput = {
  /** DeleteOverrides: pass true to also delete the FeatureOverrides for this user */
  DeleteOverrides: Scalars['Boolean'];
  /** ModifiedBy: the identifier of the user who changed this status (comes from Retool) */
  ModifiedBy: Scalars['String'];
  /** Reason: a Linear ticket number. Must be in the format "COM-5****' where **** are optional numbers */
  Reason: Scalars['String'];
  Status: UserComplianceStatus;
  UserID: Scalars['UserID'];
};

/** UserComplianceStatus: see, https://www.notion.so/thenoahapp/NIP-11-User-Status-1577fc6d2308485da5efd5e7b24541cd */
export enum UserComplianceStatus {
  Active = 'Active',
  Investigating = 'Investigating',
  Reported = 'Reported',
  Suspended = 'Suspended',
}

export type UserFiatPaymentCurrencyUpdate = {
  FiatCurrencyCode: FiatCurrencyCode;
  FiatPaymentCurrencyCode: FiatCurrencyCode;
};

/** UserGroup: group that user can belong to */
export enum UserGroup {
  /** Beta: user has access to beta features */
  Beta = 'Beta',
  /** Business: user has access to business features */
  Business = 'Business',
  /** Noah: for noah employees - should have access to all features, even globally disabled ones */
  Noah = 'Noah',
}

export type UserIdentificationFile = {
  /** FileSide: The side of the file returned */
  FileSide?: Maybe<IdentificationFileSide>;
  /** IssuingCountryCode: The country that issued the id. */
  IssuingCountryCode?: Maybe<Scalars['CountryCode']>;
  /** Kind: The kind of file returned */
  Kind: IdentityType;
  /** URL: A url link to download the file. It is advisable to set an expiration time of 30 seconds on the link, to add an additional layer of security. */
  URL: Scalars['AWSURL'];
};

export type UserLimit = {
  /** When the FiatAmount is null, the user has no limit for the given period */
  FiatAmount?: Maybe<FiatAmount>;
  /** LimitType: the type of the limit */
  LimitType: UserLimitType;
  /** Period: the period of the limit */
  Period: PolicyPeriod;
  /** Format of the signature: v1/DateTime/base64(sign(DateTime/LimitType/Period/FiatCurrency/FiatAmount)) */
  Signature: Scalars['String'];
};

export type UserLimitFiatAmountInput = {
  /** Amount: amount of fiat currency */
  Amount: Scalars['Decimal'];
  /** Currency: used fiat currency */
  FiatCurrency: FiatCurrencyCode;
};

export type UserLimitInput = {
  /** When the FiatAmount is null, the user has no limit for the given period */
  FiatAmount?: InputMaybe<UserLimitFiatAmountInput>;
  /** LimitType: the type of the limit */
  LimitType: UserLimitType;
  /** Period: the period of the limit */
  Period: PolicyPeriod;
  /** Format of the signature: v1/DateTime/base64(sign(DateTime/LimitType/Period/FiatCurrency/FiatAmount)) */
  Signature: Scalars['String'];
};

/** UserLimitResponse: returns user's limit and usage */
export type UserLimitResponse = {
  /** Limits: user's limits and usage */
  Limits: Array<OrderLimitPolicy>;
};

/** UserLimitTransaction: represents a transaction that helps calculate user's limit */
export type UserLimitTransaction = {
  /** Created: date when the transaction was created */
  Created: Scalars['AWSDateTime'];
  /** DynamoID: [OrderType]/[Network]/[ID] */
  DynamoID: Scalars['DynamoID'];
  /** Expiry time of the transaction in DynamoDB */
  DynamoTTL: Scalars['Int'];
  /** FiatAmount: the fiat amount for this transaction */
  FiatAmount: FiatAmount;
  /** UserID: identifies the owner of this transaction */
  UserID: Scalars['UserID'];
};

export enum UserLimitType {
  Signing = 'Signing',
}

export type UserLimitUpdateInput = {
  SigningDayLimit: UserLimitInput;
  SigningSingleLimit: UserLimitInput;
};

export type UserLimitUpdateResponse = {
  limits: Array<UserLimit>;
};

/** UserLimitsIndexedFields: index fields on ledger userlimits table */
export enum UserLimitsIndexedFields {
  UserID = 'UserID',
}

export type UserMetadata = {
  /** GooglePlayStoreAppReviewed: timestamp when the google play store app review dialog was displayed to the user */
  GooglePlayStoreAppReviewed?: Maybe<Scalars['AWSDateTime']>;
  /** GroupBetaClaimed: timestamp of a first login after becoming beta */
  GroupBetaClaimed?: Maybe<Scalars['AWSDateTime']>;
  /** GroupBetaGranted: timestamp when a user was added to beta list */
  GroupBetaGranted?: Maybe<Scalars['AWSDateTime']>;
  /** QuestsCompleted: quests which the user has completed */
  QuestsCompleted?: Maybe<Array<Scalars['QuestID']>>;
  /** QuestsInProgress: quests which the user is currently working on */
  QuestsInProgress?: Maybe<Array<Scalars['QuestID']>>;
  /** RewardsNoahPointsAvailable: number of noah points available */
  RewardsNoahPointsAvailable?: Maybe<Scalars['Int']>;
  /** RewardsNoahPointsLifetime: number of lifetime noah points */
  RewardsNoahPointsLifeTime?: Maybe<Scalars['Int']>;
  /** RewardsNoahPointsVersion: version of the noah points in the ledger */
  RewardsNoahPointsVersion?: Maybe<Scalars['Int']>;
  /** TxBtcDepositFirst: timestamp of a first BTC deposit */
  TxBtcDepositFirst?: Maybe<Scalars['AWSDateTime']>;
  /** TxBtcDepositLatest: timestamp of a latest BTC deposit */
  TxBtcDepositLatest?: Maybe<Scalars['AWSDateTime']>;
  /** TxBtcWithdrawFirst: timestamp of a first BTC withdraw */
  TxBtcWithdrawFirst?: Maybe<Scalars['AWSDateTime']>;
  /** TxBtcWithdrawLatest: timestamp of a latest BTC withdraw */
  TxBtcWithdrawLatest?: Maybe<Scalars['AWSDateTime']>;
};

export type UserMetadataUpdateInput = {
  GooglePlayStoreAppReviewed?: InputMaybe<Scalars['AWSDateTime']>;
};

export type UserProfile = {
  /** AvatarUrl: user's avatar */
  AvatarUrl?: Maybe<Scalars['String']>;
  /** BotData: Network traffic data for suspected bots */
  BotData?: Maybe<BotData>;
  /** ComplianceState: details a user's compliance status */
  ComplianceState?: Maybe<UserComplianceState>;
  /** Created: when the user profile was created */
  Created?: Maybe<Scalars['AWSDateTime']>;
  /** DateOfBirth: user's date of birth */
  DateOfBirth?: Maybe<Scalars['AWSDate']>;
  /** DisplayUnit: the currency unit the user prefers to display their balance in defaults to the currency code if this is null */
  DisplayUnit: CurrencyUnit;
  /** Email: user email */
  Email: Scalars['AWSEmail'];
  /** FeatureFlags: defines which features user can access */
  FeatureFlags?: Maybe<Array<FeatureFlag>>;
  /** FeatureOverrides: explicitly set status of features */
  FeatureOverrides?: Maybe<Array<FeatureFlag>>;
  /** FiatCurrencyCode: the fiat currency the user prefers to display their balance */
  FiatCurrencyCode: FiatCurrencyCode;
  /** FiatPaymentCurrencyCode: the fiat currency the user prefers to do payments on on-ramping and off-ramping flows */
  FiatPaymentCurrencyCode?: Maybe<FiatCurrencyCode>;
  /** Files: user's files */
  Files?: Maybe<Array<Maybe<UserIdentificationFile>>>;
  /** Groups: groups that the user belongs to */
  Groups?: Maybe<Array<UserGroup>>;
  /** HomeAddress: user's home address. */
  HomeAddress?: Maybe<KycAddress>;
  /** Kyb: Data related the user's KYB verification */
  Kyb?: Maybe<Kyb>;
  /** KycRetryCount: Number of times user has retried KYC */
  KycRetryCount?: Maybe<Scalars['Int']>;
  /** KycVerification: Data related to user's KYC verification */
  KycVerification: KycVerification;
  /** LatestCountry: country where user is currently located */
  LatestCountry?: Maybe<Scalars['CountryCode']>;
  /** LatestRegion: region where user is currently located */
  LatestRegion?: Maybe<Scalars['RegionCode']>;
  /** Limits: the limits that the user defined for themselves */
  Limits?: Maybe<Array<UserLimit>>;
  /** Metadata: metadata about the user */
  Metadata: UserMetadata;
  /** Nationality: user's nationality, represented by a `CountryCode`. */
  Nationality?: Maybe<Scalars['CountryCode']>;
  /**
   * PersonalName: user's full personal name.
   * https://en.wikipedia.org/wiki/Personal_name
   */
  PersonalName?: Maybe<FullName>;
  /**
   * PhoneNumber: a user's phone number -- potentially including a country code.
   *
   * See: https://docs.aws.amazon.com/appsync/latest/devguide/scalars.html
   */
  PhoneNumber?: Maybe<Scalars['AWSPhone']>;
  /** PrimaryCurrency: the currency the user prefers to be displayed as primary */
  PrimaryCurrency: CurrencyDisplayType;
  /** Referrals: number of users this user has referred */
  Referrals: Scalars['Int'];
  /** ReferrerReferral: referral code of the user that referred this user */
  ReferrerReferral?: Maybe<Scalars['String']>;
  /** UserID: identifies the owner of this account */
  UserID: Scalars['UserID'];
  /** Username: username registered for the profile in lowercase */
  Username: Scalars['String'];
  /** UsernameDisplay: username registered for the profile */
  UsernameDisplay: Scalars['String'];
};

export type UserProfileCreateInput = {
  AvatarUrl: Scalars['String'];
  /** Country: a honeypot field that should be null for human users */
  Country?: InputMaybe<Scalars['String']>;
  ReferrerReferral?: InputMaybe<Scalars['String']>;
  UsernameDisplay: Scalars['String'];
};

export type UserSettingsConsent = {
  CommitHash: Scalars['String'];
  Cookies?: Maybe<CookieConsent>;
  Created: Scalars['AWSDateTime'];
  EmailContact: Scalars['Boolean'];
  Source?: Maybe<UserSettingsConsentSource>;
  Terms: Scalars['Boolean'];
  UserID: Scalars['UserID'];
};

export type UserSettingsConsentInput = {
  CommitHash: Scalars['String'];
  Cookies: CookieConsentInput;
  EmailContact: Scalars['Boolean'];
  Terms: Scalars['Boolean'];
};

export enum UserSettingsConsentSource {
  Segment = 'Segment',
  User = 'User',
}

export type ValidateReferralCodeInput = {
  ReferralCode: Scalars['String'];
};

/** VolumeLimit: A limit on the total volume over a time period */
export type VolumeLimit = {
  /** Limit: the limit amount */
  Limit?: Maybe<FiatAmount>;
  /** Minimum: a minimum threshold that must be exceeded */
  Minimum?: Maybe<FiatAmount>;
  /** Signing: a threshold that, when exceeded, requires a signature */
  Signing?: Maybe<FiatAmount>;
  /** Usage: used fiat currency */
  Usage?: Maybe<FiatAmount>;
};

/**
 * WebhookDocument: a record of any important raw events
 * It extracts data that we need for indexing and records the full raw event as a string / json.
 */
export type WebhookDocument = {
  /** EventID: ID of the webhook */
  EventID: Scalars['ID'];
  /** EventTime: The time of the raw event */
  EventTime: Scalars['AWSDateTime'];
  /** Hash: Uniquely identifies the event message */
  Hash: Scalars['String'];
  /** PublicID */
  PublicID: Scalars['String'];
  /** RawEvent: The raw event */
  RawEvent: Scalars['AWSJSON'];
};

export enum WebhookEventType {
  CheckoutSession = 'CheckoutSession',
  Transaction = 'Transaction',
}

export type WebhookSubscription = {
  /** Created: The time the subscription was created */
  Created: Scalars['AWSDateTime'];
  /** EventTypes: The types of events that the webhook will be sent for */
  EventTypes: Array<WebhookEventType>;
  /** ID: The ID that the subscription is for */
  ID: Scalars['KSUID'];
  /** Url: The URL that the webhook will be sent to */
  Url: Scalars['AWSURL'];
  /** UserID: The user that created the subscription */
  UserID: Scalars['UserID'];
};

export type WebhookSubscriptionCreateInput = {
  EventTypes: Array<WebhookEventType>;
  Url: Scalars['String'];
};

export type WebhookSubscriptionDeleteInput = {
  ID: Scalars['KSUID'];
};

/** WhitelistAddress: whitelisted address */
export type WhitelistAddress = {
  /** DestinationAddress: address user can send funds to */
  DestinationAddress: DestinationAddress;
  /** ID: identifies a whitelist address */
  ID: Scalars['WhitelistID'];
  /** Name: user defined name, max 20 characters */
  Name: Scalars['String'];
};

/** WhitelistAddressCreateInput: request to add an address to whitelist */
export type WhitelistAddressCreateInput = {
  /** AccountType: type of account e.g. current / savings / loan */
  AccountType: AccountType;
  /** CurrencyCode: the currency code of this account's base currency e.g. BTC / ETH */
  CurrencyCode: CurrencyCode;
  /** DestinationAddress: address user can send funds to */
  DestinationAddress: DestinationAddressInput;
  /** Name: user defined name, max 20 characters */
  Name: Scalars['String'];
};

/** WhitelistAddressDeleteInput: request to remove an address from whitelist */
export type WhitelistAddressDeleteInput = {
  /** AccountType: type of account e.g. current / savings / loan */
  AccountType: AccountType;
  /** CurrencyCode: the currency code of this account's base currency e.g. BTC / ETH */
  CurrencyCode: CurrencyCode;
  /** ID: identifies a whitelist address to remove */
  ID: Scalars['WhitelistID'];
};

export type WhitelistUser = {
  Created?: Maybe<Scalars['AWSDateTime']>;
  Email: Scalars['String'];
  Groups: Array<UserGroup>;
  Source?: Maybe<Scalars['String']>;
};

/** WithdrawFee: fees paid for withdraw */
export type WithdrawFee = {
  /** FeeQuote: withdraw fee quote, returned when Transaction is provided */
  FeeQuote?: Maybe<Scalars['JWT']>;
  /** NetworkFee: fee for covering network costs in input currency */
  NetworkFee: Scalars['Decimal'];
};

/** WithdrawFeeInput: withdraw fee calculation input */
export type WithdrawFeeInput = {
  /** Currency: currency withdrawn */
  Currency: CurrencyCode;
  /** Network: network to withdraw on */
  Network: Network;
  /** Transaction: calculate fee for specific transaction */
  Transaction?: InputMaybe<WithdrawFeeTransactionInput>;
};

/** WithdrawFeeTransactionInput: transaction details for withdraw fee calculation */
export type WithdrawFeeTransactionInput = {
  /** Amount: absolute amount the receiver gets */
  Amount: Scalars['Decimal'];
  /** DestinationAddress: address to withdraw to */
  DestinationAddress: DestinationAddressInput;
  /** Gross: amount includes the withdraw fee */
  GrossAmount?: InputMaybe<Scalars['Boolean']>;
};

export type WithdrawOrder = {
  /**
   * AdminUserIDs: identifies admin users authorising this order. Used with ComplianceReason.
   * In chronological order: first proposer, then approvals.
   */
  AdminUserIDs?: Maybe<Array<Scalars['UUID']>>;
  /**
   * Amount: gross amount deducted in account's base currency unit (like BTC / ETH / USDC).
   * Includes the network fee.
   */
  Amount: Scalars['Decimal'];
  /** ApproveStatus: approval status of the order */
  ApproveStatus?: Maybe<WithdrawOrderApproveStatus>;
  /**
   * ApprovedFireblocksID: fireblocks transaction that was approved for
   * co-signing based on this order
   */
  ApprovedFireblocksID?: Maybe<Scalars['FireblocksID']>;
  /**
   * ComplianceReason: reason (of UserComplianceState.Reason) for cases where compliance is legally
   * required to refund user funds. Signature is not required for compliance reverses.
   */
  ComplianceReason?: Maybe<Scalars['String']>;
  /** Created: date when the withdraw was created */
  Created: Scalars['AWSDateTime'];
  /** Currency: the currency type of the transaction */
  Currency: CurrencyCode;
  /** CustomerID: ID of the customer for this withdraw */
  CustomerID?: Maybe<Scalars['CustomerID']>;
  /** DestinationAccountID: identifies the destination account ID in case of internally routed withdrawal */
  DestinationAccountID?: Maybe<Scalars['AccountID']>;
  /** DestinationAddress: destination of the withdraw */
  DestinationAddress?: Maybe<DestinationAddress>;
  /** DestinationID: the destination ID of the type specified by DestinationType */
  DestinationID?: Maybe<Scalars['String']>;
  /** DestinationType: type of destination ID */
  DestinationType?: Maybe<TransferDestinationType>;
  /** ExternalTransactionID: identifies transaction in destination. Can be manipulated by user. */
  ExternalTransactionID?: Maybe<Scalars['String']>;
  /** ID: id of the order */
  ID: Scalars['WithdrawOrderID'];
  /** IsRollBackAllowed: is the balance rollback of this order allowed */
  IsRollbackAllowed: Scalars['Boolean'];
  /**
   * MarketAmount: amount of fiat that the crypto was worth at the time the order
   * was committed to ledger
   */
  MarketAmount?: Maybe<FiatAmount>;
  /** Network: network of the order */
  Network: Network;
  /** NetworkFee: fee taken from Amount to cover network costs. */
  NetworkFee?: Maybe<Scalars['Decimal']>;
  /** NoahID: transaction created for this order */
  NoahID?: Maybe<Scalars['NoahID']>;
  /** Nonce: unique value sent from client. */
  Nonce?: Maybe<Scalars['Nonce']>;
  /**
   * RequestedAmount: amount of fiat that user requested to transact.
   * This amount is informative and can be manipulated by user.
   * Market and order amounts are expected to be near this number but
   * this might be what user expects to see and might be easier to read.
   */
  RequestedAmount?: Maybe<FiatAmount>;
  /** Reverses: transaction that this withdraw reverses (may reverse partially) */
  Reverses?: Maybe<Scalars['NoahID']>;
  /**
   * Signature: signature with user's signing key, of the form v1/DateTime/base64(sign(Nonce/DateTime/CurrencyCode/AccountType/Amount/Destination))
   * Nonce, which uniqueness is enforced, is included to verify that signature is not reused.
   * Signature is valid for 10 minutes.
   *
   * Some fields are optional and if they're defined they'll be included in the signature with a tag in the following order:
   * 1. /NetworkFee:value
   */
  Signature?: Maybe<Scalars['String']>;
  /** SourceAccountID: identifies the source account ID */
  SourceAccountID: Scalars['AccountID'];
  /** Status: the current status of the order on ledger */
  Status: WithdrawOrderStatus;
  /** Steps: is a record of the outcome of our validation & verification steps */
  Steps: TransactionSteps;
};

export enum WithdrawOrderApproveStatus {
  /** Approved: The order has been approved by the co-signer or as a result of a successful webhook */
  Approved = 'Approved',
  /** Rejected: The order has been rejected by the co-signer or as a result of a failed webhook */
  Rejected = 'Rejected',
}

/** WithdrawOrderCreateRequestInput: withdrawal request */
export type WithdrawOrderCreateRequestInput = {
  /** AccountType: which AccountType this withdrawal is from */
  AccountType: AccountType;
  /**
   * Amount: gross amount deducted in account's base currency unit (like BTC / ETH).
   * Includes the network fee.
   */
  Amount: Scalars['Decimal'];
  /** CurrencyCode: the currency code of this withdrawal request */
  CurrencyCode: CurrencyCode;
  /** CustomerID: ID of the customer for this withdraw */
  CustomerID?: InputMaybe<Scalars['CustomerID']>;
  /** Destination: transfer transaction destination */
  Destination: TransferDestination;
  /** FeeQuote: accepted quote for withdraw fees */
  FeeQuote: Scalars['JWT'];
  /** Network: network to withdraw to */
  Network: Network;
  /** Nonce: unique value sent from client. */
  Nonce?: InputMaybe<Scalars['Nonce']>;
  /**
   * RequestedAmount: fiat amount that user entered to withdraw.
   * Defining this indicates that user specifically entered this amount, not only that this amount displayed as estimate.
   */
  RequestedAmount?: InputMaybe<FiatAmountInput>;
  /**
   * Signature: signature with user's signing key, of the form v1/DateTime/base64(sign(Nonce/DateTime/CurrencyCode/AccountType/Amount/Destination))
   * Nonce, which uniqueness is enforced, is included to verify that signature is not reused.
   * Signature is valid for 10 minutes.
   *
   * Some fields are optional and if they're defined they'll be included in the signature with a tag in the following order:
   * 1. /NetworkFee:value
   */
  Signature?: InputMaybe<Scalars['String']>;
};

export enum WithdrawOrderStatus {
  /** Failed: The order has failed processing */
  Failed = 'Failed',
  /** Pending: The order is being processed */
  Pending = 'Pending',
  /** Settled: The order has been processed and found to be correct */
  Settled = 'Settled',
}

/** WithdrawOrdersIndexedFields: index fields on ledger withdraworders table */
export enum WithdrawOrdersIndexedFields {
  ExternalTransactionID = 'ExternalTransactionID',
  ID = 'ID',
  NoahID = 'NoahID',
  Nonce = 'Nonce',
}

export type RpcConnection = {
  /** implementation: the implementation for the rpc node to use. */
  implementation: RpcImplementation;
  /** path: the path of rpc endpoint */
  path?: InputMaybe<Scalars['String']>;
  /** secret: the secret used with the rpc connection */
  secret?: InputMaybe<RpcSecret>;
  /** url: the url of the node */
  url?: InputMaybe<Scalars['String']>;
};

export type RpcSecret = {
  /** token: parameter name for the secred stored in SSM. In case of QuickNode this is part of the URL. */
  token?: InputMaybe<Scalars['String']>;
};
